{
  "404.message": "A página que você estava tentando acessar não pôde ser encontrada. Isto pode ser devido a:",
  "404.message.reason1": "A página não existe.",
  "404.message.reason2": "A página existe, mas você não tem permissão para vê-la.",
  "404.nav.dashboard": "Seu Painel",
  "404.nav.home": "Página Principal",
  "404.nav.title": "Ir para",
  "404.search.title": "Busca no Site",
  "aboutpage.section.title": "Atlassian Confluence Cloud e Plugins do Confluence Cloud",
  "accessibility.user.icon": "Ícone de usuário",
  "action.add.comment": "Adicionar Comentário",
  "action.edit.comment": "Editar comentário",
  "action.reorder.pages.sentence": "Reordenar páginas",
  "action.space.addons": "Extras",
  "action.space.overview": "Visão Geral",
  "actions.word": "Ações",
  "add.comment": "Adicionar Comentário",
  "add.comment.accesskey": "m",
  "add.shortcut": "Adicionar atalho",
  "add.word": "Adicionar",
  "addlabels.teamlabels": "Categorias",
  "adf.translation.error.in.render.description.prod": "Atualize a página e tente novamente. Se o problema persistir, entre em contato com o <a target=\"_blank\" href=\"{link}\">Suporte da Atlassian</a>.",
  "adf.translation.error.in.render.description.staging": "Um erro ADF está impedindo a exibição do seu conteúdo. Discuta esse problema no canal <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> do Slack.",
  "adf.translation.error.in.render.title.prod": "Não foi possível exibir seu conteúdo",
  "adf.translation.error.in.render.title.staging": "Erro ADF ao exibir o conteúdo",
  "adg3.feedback.placeholder": "Conte-nos sobre sua experiência usando o Confluence para que possamos torná-lo ainda melhor.",
  "adg3.give.feedback": "Enviar feedback",
  "adg3.onboarding.docs.link": "Saiba mais",
  "adg3.onboarding.next": "Próximo",
  "adg3.onboarding.prev": "Anterior",
  "adg3.onboarding.sidebar.done": "Entendido",
  "adg3.onboarding.skip": "Pular",
  "adg3.onboarding.start": "Primeiros passos",
  "adg3.onboarding.step1.content": "Atualizamos cores, ícones e fontes para que as coisas mais importantes se tornem mais fáceis de ser encontradas e seus olhos não precisem se esforçar tanto.",
  "adg3.onboarding.step1.title": "Diga 'Olá' para a nova experiência no Confluence",
  "adg3.onboarding.step2.content": "As coisas das quais você mais precisa—procurar, criar e navegar—estão todas na barra lateral.",
  "adg3.onboarding.step2.title": "Navegação simples com a barra lateral",
  "adg3.onboarding.step3.content": "Não consegue lembrar no que estava trabalhando? O painel de busca lhe ajuda com uma lista de suas páginas visualizadas recentemente.",
  "adg3.onboarding.step3.title": "Continuar de onde parou",
  "adg3.onboarding.step4.content": "Dê sua opinião através do seu perfil para nos ajudar a torná-lo ainda melhor. Ainda não está pronto para a nova experiência? Você também pode desativá-la através do seu perfil.",
  "adg3.onboarding.step4.content.no.optout": "Os seus comentários são muito importantes para melhorar a experiência do Confluence. Conte-nos a sua opinião através do seu perfil para ajudar a tornar este site ainda melhor.",
  "adg3.onboarding.step4.title": "Nos ajude a construir a melhor Confluência",
  "adg3.onboarding.user.optin.content": "Fizemos mudanças com base nos comentários, mas continuamos a melhorar. Se tiver mais para partilhar, deixe-nos uma nota, através da opção 'Enviar comentários' que se encontra na barra lateral.",
  "adg3.onboarding.user.optin.done": "Entendido",
  "adg3.onboarding.user.optin.title": "A nova experiência Confluence já chegou para toda a gente",
  "adg3.send.feedback": "Enviar feedback",
  "adg3.sidebar.button.configure": "Configurar barra lateral",
  "adg3.sidebar.button.done": "Concluído",
  "adg3.sidebar.button.gotit": "OK",
  "adg3.sidebar.link.disable": "Desabilitar",
  "adg3.sidebar.link.enable": "Habilitar",
  "adg3.user.profile.other": "Meu Confluence",
  "admin.section.security.title": "Segurança do Usuário",
  "administration.name": "Administração",
  "all.updates.mainBanner": "Não tem muito acontecendo... Ainda.",
  "all.updates.subBanner": "Mantenha tudo o que acontece nesse site atualizado. Novas páginas, arquivos, edições e comentários irão aparecer aqui.",
  "all.updates.subBanner2": "Tempo para criar a próxima grande novidade.",
  "all.updates.title": "Todas atualizações",
  "anonymous.name": "Anônimo",
  "archived.spaces": "Espaços arquivados",
  "atlassian.can.contact": "Podemos entrar em contato com você para sabermos da sua opinião?",
  "atlassian.home.name": "Página inicial da Atlassian",
  "attach.files.no.permission": "Você precisará pedir permissão para inserir arquivos aqui.",
  "attach.files.tip.close": "Ok, entendi\\!",
  "attach.files.tip.desc": "Solte os arquivos diretamente na sua página para inseri-los.",
  "attach.files.tip.title": "Dica:",
  "attach.files.upload.files": "Enviar arquivos",
  "attach.files.upload.images": "Enviar imagens",
  "audit.logging.category.user.management": "Usuários e grupos",
  "aui.sidebar.collapse.tooltip": "Recolher barra lateral ( [ )",
  "aui.sidebar.expand.tooltip": "Expandir barra lateral ( [ )",
  "author.name": "Autor",
  "blog.personal.name": "Blog Pessoal",
  "blog.post": "Post do Blog",
  "blog.word": "Blog",
  "blogtree.failed.load.content": "Falha ao carregar posts do blog",
  "blueprint.navigation.items.create.new.template": "Criar novo template",
  "blueprint.navigation.items.create.new.template.disabled": "Somente administradores do espaço podem criar templates",
  "blueprint.navigation.items.filter.for.templates": "Filtrar templates",
  "blueprint.navigation.items.page.templates.header": "Templates de página",
  "button.cancel": "Cancelar",
  "cache.name.com.atlassian.confluence.pages.Draft": "Rascunhos",
  "calendar.share.button.keyboard.shortcut.desc": "Compartilhar",
  "calendar3.addcalendar": "Adicionar Calendar",
  "calendar3.helptip.learn.more": "Saiba mais",
  "calendar3.spacecalendars.header": "Calendários",
  "calendar3.spacecalendars.onboarding.button.add.label": "Adicionar Calendário",
  "calendar3.spacecalendars.onboarding.intro": "Adicione um calendário para acompanhar as folgas da sua equipe, planejar projetos no Jira e deixar todos bem informados a respeito de datas importantes.",
  "calendar3.spacecalendars.onboarding.title": "A fonte fidedigna para a sua equipe ou projeto",
  "cancel.name": "Cancelar",
  "captcha.response.failed": "A palavra digitada não corresponde ao texto da imagem.",
  "categories.name": "Categorias",
  "changeboarding.dnd.pagetree.spacesettings.banner": "A organização do espaço ficou mais fácil, com a possibilidade de arrastar e soltar para reordenar páginas na sua barra lateral",
  "changeboarding.dnd.pagetree.spotlight.message": "Arraste e solte para mover páginas e organizar o seu espaço.",
  "changes-diff.heading.key": "Chave",
  "changes-diff.these.lines.were.added": "Esta linha foi adicionada.",
  "changes-diff.these.lines.were.removed": "Esta linha foi removida.",
  "changes-diff.this.content.was.modified": "A formatação mudou.",
  "clear.name": "Limpar",
  "clipboardaccess.browser.not.supported": "O seu browser não suporta que sejam coladas imagens a partir do clipboard.",
  "clipboardaccess.ok": "OK",
  "close.draft.name": "Fechar rascunho",
  "close.name": "Fechar",
  "collab.edit.user.limit.msg.body": "<p>Esta página está tão popular, que você atingiu o número máximo de editores simultâneos.</p><p>Tente novamente quando não estiver não estiver tão ocupada.</p>",
  "collab.edit.user.limit.msg.title": "Você não pode editar esta página agora",
  "collab.status.connected": "Pronto para seguir",
  "collab.status.connecting": "Conectando...",
  "collab.status.error": "Não é possível salvar as alterações",
  "collab.status.tooltip.error": "Copie seu trabalho, atualize a página, e nós vamos tentar reconectar.",
  "collab.status.tooltip.failure": "Não é possível alcançar o servidor. Verifique a sua conexão de internet, enquanto tentamos reconectá-lo.",
  "collab.status.tooltip.success": "Estamos salvando automaticamente todas as suas alterações em um rascunho.",
  "collapse.name": "Comprimir",
  "colourname.property.style.bordercolour": "Bordas e Divisores",
  "colourname.property.style.breadcrumbstextcolour": "Texto da Barra de Topo",
  "colourname.property.style.headerbuttonbasebgcolour": "Côr de Fundo do Botão de Cabeçalho",
  "colourname.property.style.headerbuttontextcolour": "Texto do Botão de Cabeçalho",
  "colourname.property.style.headingtextcolour": "Texto do Título",
  "colourname.property.style.linkcolour": "Links",
  "colourname.property.style.menuitemselectedbgcolour": "Fundo do Item de Menu Selecionado",
  "colourname.property.style.menuitemselectedtextcolour": "Texto do Item de Menu Selecionado",
  "colourname.property.style.menuitemtextcolour": "Texto do Item de Menu de Página",
  "colourname.property.style.menuselectedbgcolour": "Fundo do Menu de Página Selecionado",
  "colourname.property.style.navbgcolour": "Fundo da Guia de Navegação",
  "colourname.property.style.navselectedbgcolour": "Destaque da Guia de Navegação",
  "colourname.property.style.navselectedtextcolour": "Destaque de Texto da Guia de Navegação",
  "colourname.property.style.navtextcolour": "Texto da Guia de Navegação",
  "colourname.property.style.searchfieldbgcolour": "Plano de fundo do Campo de pesquisa",
  "colourname.property.style.searchfieldtextcolour": "Texto do campo de pesquisa",
  "colourname.property.style.spacenamecolour": "Texto do nome do espaço",
  "colourname.property.style.topbarcolour": "Barra Superior",
  "colourname.property.style.topbarmenuitemtextcolour": "Texto do Item de Menu da Barra Superior",
  "colourname.property.style.topbarmenuselectedbgcolour": "Fundo do Menu Selecionado da Barra Superior",
  "colourname.property.style.topbarmenuselectedtextcolour": "Barra de Topo do Menu de Seleção de Texto",
  "com.atlassian.confluence.contributors.contributors.label": "Contribuidores",
  "com.atlassian.confluence.extra.officeconnector.viewfile.label": "Ver ficheiro",
  "com.atlassian.confluence.extra.team-calendars.calendar.helptip.close": "Consegui, muito obrigado!",
  "com.atlassian.confluence.pages.actions.EditPageAction.action.name": "Editar Página",
  "com.atlassian.confluence.plugins.confluence-roadmap-plugin.roadmap.label": "Planejador de Roteiro",
  "com.atlassian.confluence.plugins.pagetree.pagetree.label": "Árvore da Página",
  "com.atlassian.confluence.plugins.recently.viewed.filter": "Filtro",
  "com.atlassian.confluence.plugins.recently.viewed.footer.hint": "Dica: digite \"g\" e depois \"r\" em qualquer lugar para abrir este menu rapidamente",
  "com.atlassian.confluence.plugins.recently.viewed.title": "Páginas recém-exibidas",
  "com.atlassian.confluence.plugins.status-macro.status.label": "Estado",
  "com.atlassian.mywork.header.notifications": "Notificações",
  "comment.display.name.anonymous": "Anônimo",
  "comment.edit": "Editar",
  "comment.edited": "Editado",
  "comment.name.tooltip": "Adicionar um Comentário",
  "comment.notification.enable": "Observar esta página",
  "comment.permalink": "Link permanente",
  "comment.plural": "{0} Comentários",
  "comment.remove": "Eliminar",
  "comment.reply": "Responder",
  "comment.singular": "1 comentário",
  "compare.selected": "Compare as versões selecionadas",
  "configuration.name": "Configuração",
  "confluence.extra.attachments.attachments.label": "Anexos",
  "confluence.extra.jira.jira.label": "Jira",
  "confluence.extra.masterdetail.detailssummary.label": "Page Properties Report",
  "confluence.home": "Página inicial do Confluence",
  "confluence.macros.advanced.children.label": "Exibir filhos",
  "confluence.macros.advanced.contentbylabel.label": "Conteúdo por Rótulo",
  "confluence.macros.advanced.recently-updated.label": "Atualizado recentemente",
  "confluence.mobile.nav.switch.to.mobile.action": "Alternar para o Confluence móvel",
  "confluence.mobile.nav.switch.to.mobile.text": "Você está vendo a versão para Desktop em um dispositivo móvel.",
  "confluence.mobile.refresh": "Atualizar",
  "confluence.request.access.pagerestricted.inherited.description": "Isso se dá em razão de estar herdando restrições de uma página pai. Um administrador de espaço ou a pessoa que compartilhou essa página pode ser capaz de lhe conceder acesso.",
  "confluence.request.access.pagerestricted.request.access.button": "Solicitar acesso",
  "confluence.request.access.pagerestricted.requestaccess.description": "Aperte o botão de solicitação de acesso e encontraremos alguém que possa dar-lhe acesso.",
  "confluence.request.access.pagerestricted.requestaccess.title.edit.page": "Você não tem permissão para editar essa página",
  "confluence.request.access.pagerestricted.requestaccess.title.view.page": "Você não tem permissão para ver essa página",
  "confluence.user.profile.department": "Departamento",
  "confluence.user.profile.location": "Localização",
  "confluence.user.profile.position": "Posição",
  "connect.addon.wait.or": "Aguarde ou",
  "content.empty": "Texto do comentário está vazio. Não é possível criar comentários vazios.",
  "content.kind.decisions": "Decision",
  "content.kind.file-list": "File list",
  "content.kind.jirareport": "Jira report",
  "content.kind.kb-how-to-article": "How to article",
  "content.kind.kb-troubleshooting-article": "Troubleshooting article",
  "content.kind.meeting-notes": "Meeting notes",
  "content.kind.product-requirements": "Product requirements",
  "content.kind.retrospective": "Retrospective",
  "content.kind.shared-links": "Shared links",
  "content.kind.task-report": "Task report",
  "content.type.attachment": "Anexos",
  "content.type.blogpost": "Blogs",
  "content.type.page": "Páginas",
  "cq.header.title": "Questões",
  "create.blog.post.event.description": "Criar um Blog Post",
  "create.drawer.header": "Criar",
  "create.drawer.page.selector.all.pages.in.space": "Todas as páginas deste espaço",
  "create.drawer.page.selector.location.header": "Local",
  "create.drawer.page.selector.no.page.found": "Nenhuma página encontrada",
  "create.drawer.page.selector.no.parent.page": "Nenhuma página pai",
  "create.drawer.page.selector.pages.loading": "Carregando páginas",
  "create.drawer.page.selector.parent.page": "Página pai",
  "create.drawer.page.selector.parent.page.tooltip.help": "Blogs, calendários e perguntas não serão exibidos abaixo de uma página pai",
  "create.drawer.page.selector.recent.pages": "Páginas recentes",
  "create.drawer.page.selector.select.parent.page": "Selecione uma página pai",
  "create.drawer.space.selector.header": "Espaço",
  "create.drawer.space.selector.location.header": "Local",
  "create.drawer.space.selector.no.space.found": "Nenhum espaço encontrado",
  "create.drawer.space.selector.recent.spaces": "Espaços recentes",
  "create.drawer.space.selector.search.spaces": "Todos os espaços",
  "create.drawer.space.selector.select.a.space": "Selecione um espaço",
  "create.drawer.space.selector.spaces.loading": "Carregando espaços",
  "create.drawer.space.selector.starred.spaces": "Espaços marcados com estrela",
  "create.drawer.template.failed.to.load.atlassian.support": "Suporte da Atlassian.",
  "create.drawer.template.failed.to.load.content": "Atualize a página e tente novamente. Caso o problema persista, entre em contato com o",
  "create.drawer.template.failed.to.load.title": "Houve uma falha ao carregar o template",
  "create.name": "Criar",
  "css.file": "Arquivo CSS",
  "current.space": "Espaço atual",
  "default.space.homepage.title": "Página inicial de {0}",
  "delete.name": "Remover",
  "desc.colourscheme": "As seguintes cores podem ser personalizadas para este esquema de cores.",
  "description.name": "Descrição",
  "discard.name": "Rejeitar",
  "discover.applications": "Descobrir aplicativos",
  "draft": "Rascunho",
  "draft.no.content": "Este rascunho não tem conteúdo.",
  "edit.comment": "Editar comentário",
  "edit.labels": "Adicionar rótulos",
  "editor-help.fabric.help.center.feedback.item": "Feedback",
  "editor.adf.parsing.error.details": "Detalhes do erro:",
  "editor.adf.parsing.error.message.prod": "Atualize a página e tente novamente. Se o problema persistir, entre em contato com o <a target=\"_blank\" href=\"{link}\">Suporte da Atlassian</a>.",
  "editor.adf.parsing.error.message.staging": "Nossa equipe foi notificada, mas você também pode discutir isso no canal <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> do Slack.",
  "editor.adf.parsing.error.title.prod": "Não foi possível carregar o editor.",
  "editor.adf.parsing.error.title.staging": "Tivemos um problema para converter este documento para ADF",
  "editor.attachments": "{0}",
  "editor.attachments.plural": "{0} Anexos",
  "editor.attachments.singular": "{0} Anexo",
  "editor.attachments.zero": "Anexos",
  "editor.autocomplete.file.header.text": "Sugestões de arquivos",
  "editor.autocomplete.links.create.link": "Inserir link para criar a página",
  "editor.autocomplete.links.dialog.search": "Pesquisa por ‘{0}’",
  "editor.autocomplete.links.dialog.search.no.text": "Pesquisa",
  "editor.autocomplete.links.header.text": "Sugestões de links",
  "editor.autocomplete.links.web.link": "Inserir link da web",
  "editor.autocomplete.macros.dialog.browse": "Abrir navegador de macro",
  "editor.autocomplete.macros.error.load.header": "Falha ao obter detalhes da macro",
  "editor.autocomplete.macros.error.load.retrylink": "Tente novamente",
  "editor.autocomplete.macros.header.text": "Sugestões de macros",
  "editor.autocomplete.media.files.dialog.browse": "Abrir biblioteca de arquivos",
  "editor.autocomplete.media.header.text": "Sugestões de Mídia",
  "editor.autocomplete.media.images.dialog.browse": "Abrir navegador de imagem",
  "editor.autocomplete.media.macros.dialog.browse": "Inserir outra mídia",
  "editor.autoformat.sampletext.firstcell": "primeira célula",
  "editor.autoformat.sampletext.heading": "título",
  "editor.buttons.disable.by.empty.title.tooltip": "Sua página precisa de um título antes de ser publicada.",
  "editor.buttons.disable.by.not.saving.tooltip": "Só um minutinho...",
  "editor.buttons.disable.by.saving.tooltip": "Ainda estamos salvando sua página.",
  "editor.cancel.discard.changes.confirmation": "Descartar alterações",
  "editor.cancel.discard.changes.message": "Todo o conteúdo introduzido será rejeitado. Por favor confirme.",
  "editor.cancel.discard.changes.title": "Confirme a rejeição de todas as alterações",
  "editor.cant.publish.changes": "Não é possível publicar as mudanças",
  "editor.change.comment": "O que você alterou?",
  "editor.close.publish.tooltip": "Salvar alterações sem publicar",
  "editor.close.update.tooltip": "Salvar alterações sem atualizar",
  "editor.collab.user.limit.body": "Esta página está tão popular que você atingiu o número máximo de editores simultâneos. Tente novamente mais tarde.",
  "editor.collab.user.limit.title": "Você não pode editar esta página no momento",
  "editor.collaborative-editing.load.error": "O carregamento do editor está demorando mais do que o habitual. Espere alguns minutos, então atualize sua página se ela ainda não carregar. Fale com o seu administrador da Confluence se isso não corrigir o problema.",
  "editor.collaborative-editing.refresh-editor.error": "Algo deu errado ao carregar o editor, por favor, tente novamente.",
  "editor.collaborative.mode.disabled": "A edição colaborativa está off-line no momento. Copie o seu trabalho, depois atualize a página para continuar editando.",
  "editor.collaborative.mode.enabled": "A edição colaborativa foi desligada, mas ela está de volta à atividade. Copie suas alterações e atualize a página continuar editando.",
  "editor.content.appearance.toggle.fixed.width": "Configurar a página com largura inteira",
  "editor.content.appearance.toggle.full.width": "Configurar a página com largura fixa",
  "editor.content.placeholder.11": "Você sabia que é possível incluir vários itens úteis a esta página, como um índice, uma data ou um roteiro? Digite / para abrir uma lista.",
  "editor.content.placeholder.ai": "Digite /ai para Atlassian Intelligence, / para adicionar elementos ou @ para mencionar alguém (a pessoa vai ser notificada).",
  "editor.content.placeholder.bpqa": "Digite / para ver a lista de elementos, @ para mencionar alguém ou selecione abaixo:",
  "editor.content.placeholder.bpqa.ai": "Digite /ai para Atlassian Intelligence, / para elementos, @ para mencionar alguém ou selecione abaixo:",
  "editor.content.placeholder.easy.mentions": "Digite / para todos os elementos ou @ para mencionar alguém.",
  "editor.content.placeholder.slash": "Digite / para inserir qualquer elemento",
  "editor.content.placeholder.slash.bracket": "Qualquer elemento pode ser inserido bem rápido digitando /",
  "editor.content.reconciliation.error.details": "Detalhes do erro:",
  "editor.content.reconciliation.error.fatal.prod": "Nossa equipe foi notificada. Aguarde alguns minutos e tente novamente. Caso o problema persista, entre em contato com o Suporte da Atlassian.",
  "editor.content.reconciliation.error.fatal.staging": "Nossa equipe foi notificada, mas você também pode discutir isso no canal #cc-content-experience do Slack.",
  "editor.content.reconciliation.error.retrying": "Tentando novamente em {0}...",
  "editor.content.reconciliation.error.title": "Não foi possível carregar esta página",
  "editor.content.reconciliation.networkerror.fatal.prod": "Atualizar a página deve corrigir esse item. Se o problemas continuar, entre em contato com o <a href=\"https://support.atlassian.com/contact/#/\" target=\"_blank\">Suporte da Atlassian</a> ou com o administrador do espaço.",
  "editor.content.reconciliation.networkerror.title": "Estamos com dificuldades para carregar o conteúdo",
  "editor.discard-on-close.tooltip": "Descartar rascunho vazio",
  "editor.discard-to-published.button.label": "Descartar",
  "editor.discard-to-published.button.tooltip": "Reverter para a última versão publicada da página",
  "editor.discard-to-published.dialog.title": "Descartar alterações não publicadas?",
  "editor.discard-to-published.dialog.warning": "Isso irá restaurar o editor para a última versão publicada desta página. Se alguém tem alterações não publicadas na página, você estará descartando essas mudanças também.",
  "editor.discard-to-published.error.message": "Não podemos chegar a última versão publicada da página no momento. Espere alguns minutos e depois tente descartar o rascunho novamente.",
  "editor.discard-to-published.error.title": "Não é possível reverter para a última versão publicada",
  "editor.discard-to-published.success.message": "Revertido com sucesso para a última versão publicada",
  "editor.draft.can.be.migrated": "Edição colaborativa é aqui! Para que você possa continuar a trabalhar nesta página, precisamos migrar o conteúdo para um novo rascunho para você. <br> <a href={0}>Migrar agora</a>",
  "editor.dynamic-macro.preview.limit.desc": "A pré-visualização de macro dinâmico no esboço só é suportada completamente quando esboços compartilhados estiverem ativados.",
  "editor.ellipsis.blog.delete": "Excluir postagem do blog não publicada",
  "editor.ellipsis.import-document": "Abrir template e importar documento",
  "editor.ellipsis.open.template.browser": "Abrir navegador do template",
  "editor.ellipsis.open.templates.and.import": "Templates e importar documentos",
  "editor.ellipsis.page.delete": "Excluir página não publicada",
  "editor.ellipsis.remove": "Reverter para a última versão publicada",
  "editor.ellipsis.resolved.comments": "Comentários resolvidos",
  "editor.ellipsis.view-changes": "Ver mudanças",
  "editor.error.delayed.publishing": "Vamos continuar tentando publicar. Se levar muito tempo, atualize a página e clique em <strong>Publicar</strong>.",
  "editor.error.delayed.publishing.title": "Há alguns problemas para publicar o conteúdo.",
  "editor.excerpt.include.macro.error": "Erro ao carregar trecho de \"{0}\".",
  "editor.excerpt.panel.title.loading": "Carregando...",
  "editor.fabric.share.invite.to.edit.empty.blog.post.title": "Blog sem título",
  "editor.fabric.share.invite.to.edit.empty.page.title": "Página sem título",
  "editor.fabric.share.invite.to.edit.form.title": "Convidar para editar",
  "editor.files.may.be.uploading": "Alguns arquivos ainda podem estar sendo carregados. Aguarde um minuto e tente novamente. Se isso não funcionar, atualize a página e refaça o upload de qualquer arquivo que pareça quebrado antes de publicar.",
  "editor.generic.refresh": "Algo deu errado com o editor. Copie as alterações não salvas e atualize a página para continuar editando.",
  "editor.go.back": "Voltar",
  "editor.heartbeat.unauthorised.warning.generic.body": "Este conteúdo foi movido, restringido ou deletado. Recomendamos que você copie tudo que precisa e feche o editor.",
  "editor.heartbeat.unauthorised.warning.generic.title": "Sem acesso a esta página",
  "editor.heartbeat.unauthorised.warning.page-move.body": "Você não pode publicar devido a uma mudança da página ou alteração nas restrições. Recomendamos que você copie o que precisar e feche o editor.",
  "editor.heartbeat.unauthorised.warning.page-move.title": "As permissões da página mudaram",
  "editor.help.how.to.use.blueprint": "Como utilizar {blueprintType}",
  "editor.help.templates": "Use templates de página",
  "editor.help.updates": "Edição de atualizações",
  "editor.help.updates.1.description": "A primeira fase de melhorias de edição chegou aos posts de blog. Conteúdo responsivo, melhor manipulação de imagem e uma interface mais simplificada. Crie uma nova postagem no blog para conferir.",
  "editor.help.updates.1.title": "Posts de blog",
  "editor.help.updates.2.description": "A nova experiência de edição agora será lançada como notas de reunião. As últimas atualizações incluem funcionalidade de mesa avançada, a qual é ativada pelo clique em uma mesa, e melhorias na velocidade e na confiabilidade.",
  "editor.help.updates.2.title": "Notas de reunião",
  "editor.hints.close": "Fechar dicas",
  "editor.hints.next": "Próxima dica",
  "editor.labels": "{0}",
  "editor.labels.desc": "Editar Labels da página",
  "editor.labels.plural": "{0} rótulos",
  "editor.labels.singular": "Rótulo {0}",
  "editor.labels.zero": "Rótulos",
  "editor.learn.more": "Saiba mais",
  "editor.location.desc": "Adicionar local",
  "editor.minor.edit": "Notificar seguidores",
  "editor.offline.before.save.error": "Não foi possível se comunicar com o servidor. No momento não é possível salvar.",
  "editor.offline.preview.error": "Não é possível acessar o servidor. Verifique se você está conectado à internet e se o Confluence está instalado e funcionando.",
  "editor.offline.save.error": "Não é possível comunicar com o servidor. Não é possível salvar no momento.",
  "editor.offline.save.error.generic": "Houve um erro ao processar a solicitação.",
  "editor.offline.save.noauthorized": "Sua sessão expirou. Você precisará entrar novamente ou mudar de conta para continuar trabalhando.\n <div><a href=\"/login?application=confluence\">Entrar ou mudar de conta</a></div>",
  "editor.offline.save.noauthorized.title": "Não é possível conectar-se com o servidor.",
  "editor.offline.save.page.exist.content": "Uma página com o título '{'0'}' já existe neste espaço. Digite um título diferente para a página.",
  "editor.onboarding.draft.placeholder": "Digite / para obter uma lista de elementos úteis que você pode adicionar à página, como um sumário ou um roteiro.<br/>Ou, se suas ideias estiverem em branco, como esta página, comece com um dos templates à direita →",
  "editor.onboarding.spotlight.body": "Descubra o que está mudando e por quê.",
  "editor.onboarding.spotlight.finish": "Entendido",
  "editor.onboarding.spotlight.title": "Estamos atualizando seus templates, um por um",
  "editor.onboarding.step1.content": "Estamos trabalhando para fornecer as funções que você pediu, começando com melhor legibilidade, ferramentas de formatação mais inteligentes e um visual mais moderno. <br /><a href=\"{linkCAC}\" target=\"_blank\">Saiba mais sobre o que está mudando</a>",
  "editor.onboarding.step1.title": "Publicações de blog mais amigáveis",
  "editor.onboarding.step2.content": "Suas funções mais usadas na barra de ferramentas, enquanto ferramentas mais avançadas estão sob o sinal de mais. Você também tem um monte de novos emojis para alegrar seu dia! <br/><a href=\"{linkCAC}\" target=\"_blank\">Saiba mais sobre o que está mudando</a>",
  "editor.onboarding.step2.title": "Procurando alguma coisa?",
  "editor.onboarding.step3.content": "Este é um trabalho em progresso, e nós precisamos da sua ajuda para deixá-lo incrível. Envie-nos seus comentários e siga a <a href=''{linkCAC}' target='_blank'>página de Confluence</a> para se manter atualizado sobre as alterações. <br/><a href=''{linkCAC}' target='_blank'>Saiba mais sobre o que está mudando</a>",
  "editor.onboarding.step3.title": "Vamos criar uma coisa incrível juntos",
  "editor.page.can.not.be.accessed.message": "Talvez sua sessão tenha expirado. Você precisará entrar novamente ou mudar de conta para continuar trabalhando.\n <div><a href=\"/login?application=confluence\">Entrar ou mudar de conta</a></div>",
  "editor.page.can.not.be.accessed.title": "Este conteúdo não pode ser acessado.",
  "editor.page.conflict.message": "Atualize a página para tentar restabelecer a conexão.",
  "editor.page.conflict.title": "Não é possível sincronizar com o servidor.",
  "editor.page.is.too.big": "Esta página é grande demais para salvar. Você poderia dividi-la em várias páginas e usar a <a href=\"https://confluence.atlassian.com/conf51/include-page-macro-336169384.html\" target=\"_blank\">macro de inclusão de página</a> para exibir o conteúdo.",
  "editor.page.is.trashed.message": "Copie o seu conteúdo, então adicione-o a uma nova página ou <div><a href=\"{0}/pages/viewtrash.action?key={1}\" target=\"_blank\">restaure esta página da lixeira</a> e tente novamente.</div>",
  "editor.page.is.trashed.title": "Este conteúdo foi excluído",
  "editor.page.legacy.draft.deprecated": "Edição colaborativa é aqui! Isso significa que precisamos de um pouco de ajuda sua reiniciando a sessão de edição. Tudo que você precisa fazer é copiar o conteúdo, editar esta página novamente e em seguida, colá-la e salvar.",
  "editor.page.moved.message.body": "Sem problemas - você ainda pode publicar suas alterações quando estiver pronto. <br /><br /> Novo Local: {0}",
  "editor.page.moved.message.title": "{0} esta página foi movida",
  "editor.page.moved.message.unknown.mover": "Outro usuário",
  "editor.placeholder.broken.image": "Imagem quebrada",
  "editor.placeholder.broken.link": "Link quebrado",
  "editor.placeholder.broken.macro": "Macro quebrada",
  "editor.placeholder.error": "Erreur",
  "editor.preview.error": "Houve um erro ao carregar a Pré-visualização. Por favor, tente novamente mais tarde.",
  "editor.publish.blog": "Publicar",
  "editor.publish.blog.desc": "Publicar",
  "editor.publish.external.share.label": "Compartilhamento externo",
  "editor.publish.hotkey.description": "Para publicar esse conteúdo, selecione {keyCombination} no teclado.",
  "editor.publish.with.comment": "Publicar com comentário da versão...",
  "editor.publish.without.notify": "Publicar sem notificar seguidores",
  "editor.quit-dialog.button.delete.blog.exit": "Excluir postagem do blog",
  "editor.quit-dialog.button.delete.page.exit": "Excluir página",
  "editor.quit-dialog.button.discard.changes.by.many": "Descartar as alterações de <strong> todos</strong>",
  "editor.quit-dialog.button.discard.changes.by.one": "Descartar <strong>todas</strong> as alterações",
  "editor.quit-dialog.button.discard.collaborative.tooltip": "Descartar todas as alterações não publicadas",
  "editor.quit-dialog.button.discard.limited.tooltip": "Edição colaborativa está desabilitada. Você pode descartar as alterações quando ela estiver habilitada novamente.",
  "editor.quit-dialog.button.revert.blog.exit": "Reverter postagem do blog",
  "editor.quit-dialog.button.revert.page.exit": "Reverter página",
  "editor.quit-dialog.button.save.exit": "Manter rascunho",
  "editor.quit-dialog.cancel.changes.by.many": "<p>Há mudanças feitas por você e outras pessoas que não foram publicadas.</p><p> Se você descartar as alterações, você vai deletar as alterações feitas pelas seguintes pessoas, e retornar para a última versão publicada desta página. Eles não poderão recuperar o trabalho que fizeram se você fizer isso.</p> <p>Estas pessoas fizeram alterações:</p>",
  "editor.quit-dialog.cancel.changes.by.one": "<p>Você fez alterações que ainda não foram publicadas.</p><p>Se você descartar as alterações, suas alterações não publicadas serão apagadas. Você não pode desfazer essa ação.</p>",
  "editor.quit-dialog.delete.blogpost.changes.by.many": "Isso excluirá permanentemente esta publicação em que você e estas outras pessoas trabalharam, .",
  "editor.quit-dialog.delete.blogpost.changes.by.one": "A exclusão de uma postagem do blog não publicada é definitiva.",
  "editor.quit-dialog.delete.page.changes.by.many": "Isso excluirá permanentemente esta página, onde você e essas outras pessoas têm trabalhado.",
  "editor.quit-dialog.delete.page.changes.by.one": "A exclusão de uma página não publicada é definitiva.",
  "editor.quit-dialog.last.edited": "Editado por último",
  "editor.quit-dialog.link.hide.diff": "Esconder alterações",
  "editor.quit-dialog.link.show.diff": "Exibir alterações",
  "editor.quit-dialog.publish.changes": "<p>Existem publicações feitas por você e outras pessoas que ainda não foram publicadas.</p><p>Estas pessoas fizeram alterações:</p>",
  "editor.quit-dialog.revert.blogpost.changes.by.one": "Isso excluirá permanentemente todas as mudanças que você realizou desde a última vez que essa postagem do blog foi publicada",
  "editor.quit-dialog.revert.changes.by.many": "Isso excluirá permanentemente todas as mudanças que as pessoas a seguir realizaram desde a última vez que essa página foi publicada.",
  "editor.quit-dialog.revert.page.changes.by.one": "Isso excluirá permanentemente todas as mudanças que você realizou desde a última vez que essa página foi públicada.",
  "editor.quit-dialog.title.blogpost.delete": "Excluir postagem do blog não publicada?",
  "editor.quit-dialog.title.discard": "Reverter para a última versão publicada?",
  "editor.quit-dialog.title.exit": "Fechar o editor",
  "editor.quit-dialog.title.page.delete": "Excluir página não publicada?",
  "editor.quit-dialog.title.publish": "Publicar todas as alterações?",
  "editor.restrictions.desc": "Editar restrições da página",
  "editor.return.to.edit": "Retornar para o Modo de Edição",
  "editor.satisfaction.survey.description": "Como foi a sua experiência de edição?",
  "editor.satisfaction.survey.final.description": "Sua opinião foi enviada",
  "editor.satisfaction.survey.final.title": "Obrigado",
  "editor.satisfaction.survey.question.bad": "Lamentamos ouvir isso. O que deu errado? (opcional)",
  "editor.satisfaction.survey.question.good": "Obrigado! Do que mais você gostou? O que poderia ser melhorado? (opcional)",
  "editor.satisfaction.survey.title": "Sua página foi publicada",
  "editor.save.draft.desc": "Guardar o seu rascunho",
  "editor.save.page.desc": "Guarde a sua página",
  "editor.shared.draft.done.desc": "Salvar rascunho; se estiver vazio, descarte",
  "editor.shared.draft.publish.desc": "Publicar alterações",
  "editor.shared.draft.update.desc": "Atualizar página publicada",
  "editor.shortcuts": "Editando atalhos de teclado",
  "editor.synchrony.publish-page.message": "{0} publicou esta página.",
  "editor.template.changing.variable.dialog.title": "Edite a variável do template",
  "editor.template.variable.input.creation.error.action": "Acessar o Suporte da Atlassian",
  "editor.template.variable.input.creation.error.description": "Atualize a página e tente novamente. Se isso continuar acontecendo, informe-nos usando o link abaixo.",
  "editor.template.variable.input.creation.error.title": "Algo deu errado",
  "editor.template.variable.list.field.placeholder": "opção1, opção2, opção 3",
  "editor.template.variable.name.field": "Nome da variável",
  "editor.title.is.empty": "Adicione um título de página antes de publicar.",
  "editor.title.is.empty.title": "Esta página precisa de um nome",
  "editor.title.placeholder": "Título da página",
  "editor.title.too.long": "Título não pode ser maior do que 255 caracteres.",
  "editor.unavailable.generic.body": "Edição não está disponível no momento. Tente novamente em alguns minutos.",
  "editor.unavailable.title": "Não é possível editar",
  "editor.unpublished.changes.lozenge.label": "Não publicado",
  "editor.unpublished.changes.lozenge.tooltip": "Esta página tem alterações não publicadas",
  "editor.waiting.to.publish.changes": "Pode haver um upload de arquivo ainda em progresso.",
  "editor.waiting.to.publish.changes.title": "Seja paciente. Está demorando um pouco.",
  "email.text.added.by": "Adicionado por",
  "error.connection.lost.body": "Aguardaremos aqui até que você se reconecte.",
  "error.connection.lost.title": "Parece que você perdeu a conexão.",
  "error.connection.recovered.action": "Recarregar o conteúdo",
  "error.connection.recovered.title": "Conectado novamente",
  "error.notfound.title": "Droga, não conseguimos encontrar a página.",
  "error.recovery.body": "Suas alterações estão seguras. Atualize a página e tente de novo.",
  "error.recovery.title": "Algo deu errado ao carregar o editor",
  "error.server-error.body": "Tente mais tarde.",
  "error.server-error.title": "Aconteceu algo errado.",
  "error.session.expired.body": "Vamos esperar um pouco mais da próxima vez, prometemos.",
  "error.session.expired.title": "Parece que perdemos sua sessão.",
  "excel.file": "Planilha do Microsoft Excel",
  "excel.macro.file": "Planilha Microsoft Excel Macro-Enabled",
  "excel.template.file": "Template Microsoft Excel",
  "excel97.file": "Planilha Microsoft Excel",
  "excel97.template.file": "Template Microsoft Excel 97",
  "existing.blogpost.placeholder": "Título do post do blog",
  "expand-macro.default-title": "Clique aqui para expandir...",
  "expand.name": "Expandir",
  "fabric.editor.announcement.datednotice.main": "Em {0}, você terá acesso à nossa nova experiência de edição.",
  "fabric.editor.announcement.dismiss": "Ignorar",
  "fabric.editor.announcement.greeting": "Olá, {0}.",
  "fabric.editor.announcement.initialnotice.main": "Em algumas semanas, a forma como você cria conteúdo no Confluence mudará.",
  "fabric.editor.announcement.link.action": "Descubra o que mudará e quais funções novas você receberá.",
  "fabric.editor.announcement.rollbacknotice.action": "Leia o comunicado sobre como restaurar a experiência antiga nas páginas existentes.",
  "fabric.editor.announcement.rollbacknotice.main": "Recentemente, suas páginas foram atualizadas de modo acidental para a nova experiência de edição. Já desfizemos essa alteração.",
  "fabric.editor.announcement.tryit.action": "Teste-a em uma nova página.",
  "fabric.editor.announcement.tryitnotice.main": "Com a nova experiência de edição, você tem páginas mais bonitas e novas funções, como macros em tempo real.",
  "fabric.editor.changeboarding.banner.action": "Veja os recursos novos à sua disposição.",
  "fabric.editor.changeboarding.banner.dismiss": "Ignorar",
  "fabric.editor.changeboarding.banner.main": "Olá, {0}! Estamos fazendo algumas mudanças para ajudar você a criar conteúdos mais fáceis de ler e com visual aprimorado.",
  "fabric.editor.page.removed.description": "Atualize a página agora.",
  "fabric.editor.page.removed.title": "Esta página foi excluída ou arquivada há pouco tempo",
  "fabric.editor.permission.removed.description": "As permissões desta página foram alteradas. Entre em contato com um administrador para obter ajuda.",
  "fabric.editor.permission.removed.title": "Você não pode exibir esta página",
  "fabric.full.width.help.center.dialog.title": "New! Width control",
  "fabric.full.width.help.center.pageElement.details": "<p>Expande <strong>todos os elementos da página</strong> na horizontal, o que gera menos espaço em branco. A opção também faz o conteúdo da página voltar para a largura fixa.</p>",
  "fabric.full.width.help.center.pageElement.title": "Full-width page toggle",
  "fabric.full.width.help.center.tableElement.details": "<p>Controla a largura de <strong>cada coluna, tabela</strong> e da maioria das <strong>macros</strong> usando opções de largura total; também é possível determinar que alguns elementos mantenham a largura fixa.</p>",
  "fabric.full.width.help.center.tableElement.title": "Opção de elemento individual",
  "fabric.help.center.columns.details": "<p>Adicione uma <strong>coluna</strong> à sua página e, em seguida, use o <strong>menu flutuante</strong> para alternar entre configurações com 2 ou 3 colunas.</p>",
  "fabric.help.center.columns.title": "Colunas",
  "fabric.help.center.dialog.title": "Aprenda o básico",
  "fabric.help.center.imageDisplay.details": "<p>Selecione uma imagem. Em seguida, arraste as <strong>alças</strong> para redimensioná-la ou use o <strong>menu flutuante</strong> para alterar o alinhamento dela.</p>",
  "fabric.help.center.imageDisplay.title": "Exibição de imagens",
  "fabric.help.center.layouts.details": "<p>Use <kbd>←</kbd> <kbd>→</kbd> para alterar a disposição de colunas, tabelas e macros.</p><p>Escolha entre uma <strong>largura fixa</strong>, que permanece igual em todas as telas, uma <strong>largura total</strong>, que se expande para preencher o espaço, ou uma versão <strong>larga</strong> intermediária.</p>",
  "fabric.help.center.layouts.title": "Layouts",
  "fabric.help.center.menuitem.title": "Tutorial",
  "fabric.help.center.slashCommands.details": "<p>Digite <kbd>/</kbd> para abrir um menu e inserir conteúdo como <strong>tabelas</strong>, <strong>macros</strong> e <strong>datas</strong> à sua página enquanto você trabalha.</p>",
  "fabric.help.center.slashCommands.title": "Comandos de barra",
  "fabric.help.center.spotlight.body": "Volte aqui a qualquer momento para rever o tutorial.",
  "fabric.help.center.spotlight.header": "Precisa fazer uma reciclagem?",
  "fabric.help.center.tableManipulation.details": "<p>Edite ou formate tabelas no <strong>menu suspenso</strong> de <strong>bordas da tabela</strong> e no <strong>menu flutuante</strong>.</p>",
  "fabric.help.center.tableManipulation.title": "Manipulação de tabelas",
  "fabric.help.center.templates.details": "<p>Encontre um template que atenda às suas necessidades. Reabra o painel a partir do menu Mais ações (•••) quando ele estiver fechado.</p>",
  "fabric.help.center.templates.title": "Templates",
  "fabric.help.center.title": "Aprenda o básico",
  "fabric.insert.external.image": "Inserir imagem da Web",
  "fabric.template.can.not.parse.content": "Não foi possível abrir este template porque ele tem elementos incompatíveis ou corrompidos.",
  "fabric.template.can.not.save.error.title": "Não é possível salvar as alterações",
  "fabric.template.can.not.save.error.title.duplicate": " Já existe um template chamado <strong>{0}</strong>. Escolha outro título para o template para poder salvar.",
  "fabric.template.found.invalid.node": "Diversas variáveis de template com o mesmo nome \"{variableNames}\", mas com parâmetros diferentes.",
  "favourite.spaces": "Meus espaços",
  "feedback.flag.thanks.description": "Seus comentários nos ajudarão a oferecer melhores experiências.",
  "feedback.flag.thanks.title": "Obrigado!",
  "filter.name": "Filtrar",
  "gif.file": "Arquivo GIF",
  "global.spaces": "Espaços do site",
  "globaladminbilling.label": "Faturamento",
  "header.or.footer.unsupported.macros.list": "No momento, as macros a seguir não são compatíveis no {0}:",
  "header.or.footer.unsupported.macros.title": "Macros não compatíveis",
  "heading.comment": "Alterado Por",
  "heading.createpage": "Criar Página",
  "heading.createpage.sentence": "Criar página",
  "heading.operations": "Operações",
  "heading.version.date": "Publicado",
  "heading.version.number": "Versão",
  "help.name": "Ajuda",
  "help.us.improve": "Ajude-nos a melhorar",
  "hipchat.presence.status.available": "Disponível",
  "hipchat.presence.status.away": "Ausente",
  "hipchat.presence.status.dnd": "Não perturbe",
  "hipchat.presence.status.offline": "Offline",
  "html.file": "Arquivo HTML",
  "icon.tooltip.remove": "Remover",
  "icon.tooltip.undo": "Desfazer",
  "image.browser.imageurl.label": "URL de imagem",
  "image.height": "Altura",
  "image.properties.dialog.cancel": "Cancelar",
  "image.properties.dialog.heading": "Propriedades da Imagem",
  "image.properties.trigger": "Propriedades",
  "image.properties.trigger.tooltip": "Configurar propriedades de imagem adicional.",
  "inline.comment.sidebar.navigate.next.description": "Próximo comentário em linha",
  "inline.comment.sidebar.navigate.previous.description": "Comentário em linha anterior",
  "inline.comments.GROW-1507.dialog.close.label": "Fechar",
  "inline.comments.GROW-1507.dialog.content": "Você conhece os comentários em linha?<br>Você pode usá-los para revisão, adicionando-os a uma parte específica de um documento.",
  "inline.comments.GROW-1507.dialog.header": "Comentários em linha",
  "inline.comments.GROW-1507.dialog.ok.label": "OK, entendi",
  "inline.comments.GROW-1507.dialog.showme.label": "Mostre para mim",
  "inline.comments.GROW-1507.dialog.title": "DICA DE COMENTÁRIO",
  "inline.comments.batch.email.view": "Ver comentário",
  "inline.comments.create.placeholder": "escreva um comentário...",
  "inline.comments.create.reply.placeholder": "Responder",
  "inline.comments.date.friendly.about.one.hour.ago": "Há 1 hora",
  "inline.comments.date.friendly.about.x.days.ago": "{0} dias atrás",
  "inline.comments.date.friendly.about.x.hours.ago": "Há {0} horas",
  "inline.comments.date.friendly.formatted": "{0}",
  "inline.comments.date.friendly.now": "há pouco",
  "inline.comments.date.friendly.one.min.ago": "Há 1 minuto",
  "inline.comments.date.friendly.x.mins.ago": "{0, plural, one {Há {0} minuto} other {Há {0} minutos}}",
  "inline.comments.date.friendly.yesterday": "ontem",
  "inline.comments.delete.confirmation.message": "Tem certeza de que deseja excluir o comentário?",
  "inline.comments.delete.permission": "Você não tem permissão para excluir este comentário.",
  "inline.comments.delete.reply.confirmation.message": "Tem certeza de que deseja excluir esta resposta?",
  "inline.comments.delete.with.reply": "Não é possível excluir encadeamentos de um comentário em linha com respostas.",
  "inline.comments.delete.with.reply.need.reload": "Não é possível excluir este comentário porque há novas respostas neste encadeamento. Recarregue-o para vê-las.",
  "inline.comments.edit.permission": "Você não tem permissão para editar este comentário.",
  "inline.comments.editor.lost": "O seu comentário será perdido.",
  "inline.comments.editor.timeout": "O editor não foi carregado corretamente. {0}Recarregue a página{1} para tentar novamente.",
  "inline.comments.expand.replies": "{0} respostas mais",
  "inline.comments.fabric.editor.error.cannot.be.empty": "Seu comentário está vazio. Adicione seu feedback e clique em Salvar.",
  "inline.comments.fabric.editor.error.captcha.check.failed": "Erro na verificação do captcha",
  "inline.comments.fabric.editor.error.captcha.check.succeeded": "Sucesso na verificação do captcha",
  "inline.comments.fabric.editor.error.create.not.permitted": "Não é possível criar comentários em função de suas configurações de permissão. Verifique com o administrador se você precisa deste recurso.",
  "inline.comments.fabric.editor.error.delete.not.permitted": "Não é possível excluir comentários em função de suas configurações de permissão. Verifique com o administrador se você precisa deste recurso.",
  "inline.comments.fabric.editor.error.edit.not.permitted": "Não é possível editar comentários em função de suas configurações de permissão. Verifique com o administrador se você precisa deste recurso.",
  "inline.comments.fabric.editor.error.invalid.selection": "Não foi possível criar o comentário. Destaque textos mais específicos para tornar a seleção mais precisa e levar o seu comentário para o conteúdo certo.",
  "inline.comments.fabric.editor.error.resolve.not.permitted": "Não é possível resolver comentários em função de suas configurações de permissão. Verifique com o administrador se você precisa deste recurso.",
  "inline.comments.fabric.editor.error.unexpected": "Algo deu errado ao salvar este comentário. Feche o comentário ou atualize a página e tente adicionar seu comentário novamente.",
  "inline.comments.fabric.editor.error.view.not.permitted": "Não é possível visualizar o comentário em função de suas configurações de permissão. Verifique com o administrador se você precisa deste recurso.",
  "inline.comments.fabric.inline.button.cancel": "Cancelar",
  "inline.comments.fabric.inline.button.save": "Salvar",
  "inline.comments.fabric.sidebar.loading.error": "Ocorreu um erro. Feche a janela de comentário e tente de novo.",
  "inline.comments.likes.error": "Curtidas não podem ser atualizadas.",
  "inline.comments.likes.like": "Curtir",
  "inline.comments.likes.unlike": "Cancelar curtida",
  "inline.comments.navigation.index.of": "{0} de {1}",
  "inline.comments.notification.email.reopened": "Reaberto",
  "inline.comments.notification.email.resolved": "Resolvido",
  "inline.comments.notification.email.view": "Ver comentário",
  "inline.comments.resolve.permission": "Você não tem permissão para resolver este comentário.",
  "inline.comments.resolved.dangling.message": "Resolvido porque o texto foi excluído por {0} {1}",
  "inline.comments.resolved.dialog.empty": "Não há comentários resolvidos nesta página.",
  "inline.comments.resolved.dialog.message": "Este comentário não foi excluído para sempre! Você pode ver os comentários resolvidos a qualquer momento.",
  "inline.comments.resolved.dialog.show.me": "Mostre para mim",
  "inline.comments.resolved.discovery.button.dismiss": "OK, entendi",
  "inline.comments.resolved.discovery.content": "Mais alguma coisa para falar? Você pode reabrir comentários resolvidos para continuar a discussão.",
  "inline.comments.resolved.menu.show.replies": "{0} respostas",
  "inline.comments.resolved.menu.show.reply": "{0} resposta",
  "inline.comments.resolved.menu.unresolve": "Reabrir",
  "inline.comments.resolved.message": "Resolvido por {0} {1}",
  "inline.comments.resolved.view.menu": "Comentários resolvidos",
  "inline.comments.server.edit.error": "Não conseguimos salvar a sua edição. O comentário deve ter sido excluído.",
  "inline.comments.server.error": "Não foi possível concluir a sua solicitação.",
  "inline.comments.server.error.edit.comment": "Não podemos editar este comentário. O comentário deve ter sido excluído.",
  "inline.comments.server.error.edit.reply": "Não podemos editar esta resposta. A resposta deve ter sido excluída.",
  "inline.comments.sidebar.cancel": "Cancelar",
  "inline.comments.sidebar.close": "Fechar",
  "inline.comments.sidebar.comment.empty": "Não é possível salvar um comentário vazio.",
  "inline.comments.sidebar.delete": "Excluir",
  "inline.comments.sidebar.deleted": "Excluído(s)",
  "inline.comments.sidebar.discard": "Descartar",
  "inline.comments.sidebar.edit": "Editar",
  "inline.comments.sidebar.error.create.comment": "Não podemos adicionar o seu comentário em linha; a seção que você realçou deve conter uma macro ou uma menção a um usuário. Tente realçar o texto simples.",
  "inline.comments.sidebar.error.delete.generic": "Erro ao excluir comentário. Verifique os logs do Confluence quanto a erros.",
  "inline.comments.sidebar.error.delete.unauthorised": "Você não tem permissões suficientes para excluir este comentário.",
  "inline.comments.sidebar.error.empty": "Insira o seu comentário.",
  "inline.comments.sidebar.error.save.comment": "Não foi possível salvar o comentário",
  "inline.comments.sidebar.error.save.reply": "Não foi possível salvar a resposta",
  "inline.comments.sidebar.error.stale": "O conteúdo da página está desatualizado; {0}atualize{1} e tente novamente.",
  "inline.comments.sidebar.like": "Curtir",
  "inline.comments.sidebar.pagecomment.success": "O comentário da página foi criado com êxito",
  "inline.comments.sidebar.reply": "Responder",
  "inline.comments.sidebar.resolve": "Resolver",
  "inline.comments.sidebar.resolved": "Resolvido",
  "inline.comments.sidebar.save": "Salvar",
  "inline.comments.sidebar.saved": "Salvo",
  "inline.comments.sidebar.shortcuts.close.description": "Fechar comentário em linha",
  "inline.comments.sidebar.show.resolved.comment": "Mostrar comentários resolvidos",
  "inline.comments.sidebar.tooltip.close.description": "Fechar barra lateral (])",
  "inline.comments.sidebar.tooltip.next.ic.description": "Próximo comentário (N)",
  "inline.comments.sidebar.tooltip.previous.ic.description": "Comentário anterior (P)",
  "inline.comments.templates.create.a.comment": "<strong>comentou</strong> em uma página",
  "inline.comments.templates.resolved.a.comment": "<strong>resolveu</strong> um comentário",
  "inline.comments.templates.resolved.a.comment.dangling": "excluído o texto referenciado por um comentário em linha, de forma que o comentário foi <strong>resolvido<strong>",
  "inline.comments.templates.unresolved.a.comment": "<strong>reabriu</strong> um comentário",
  "inline.comments.unresolved.message": "Reaberto por {0} {1}",
  "jar.file": "Arquivo Java",
  "java.file": "Código-fonte Java",
  "jpeg.file": "Arquivo JPEG",
  "js.file": "Arquivo JavaScript",
  "keyboard.shortcut.alt": "Alt",
  "keyboard.shortcut.ctrl": "Ctrl",
  "keyboard.shortcut.option": "Opção",
  "keyboard.shortcut.shift": "Shift",
  "label.contains.invalid.chars": "<b>{0}</b> contém caracteres inválidos ({1}).",
  "label.name.is.too.long": "Nomes de rótulos devem ser inferiores a {0} caracteres.",
  "labels.dialog.shortcut.tip": "Dica de atalho: Na visualização da página, pressionar <b>{shortcut}</b> também abre esta caixa de diálogo",
  "labels.none": "Sem rótulos",
  "labels.title": "Rótulos",
  "last.saved": "Último guardado",
  "likes.bethefirst": "Seja o primeiro a gostar disto",
  "likes.follow": "Seguir",
  "likes.following": "Seguindo",
  "likes.like": "Curtir",
  "likes.peoplewholikethis": "Pessoas que gostam disto",
  "likes.summary.1.non-promoted": "{0} gosta disto.",
  "likes.summary.1.promoted": "{0} gosta disto.",
  "likes.summary.1.promoted.1.non-promoted": "{0} e {1} gostam disto",
  "likes.summary.2.promoted": "{0} e {1} gostam disto",
  "likes.summary.2.promoted.1.non-promoted": "{0}, {1} e {2} gostam disto",
  "likes.summary.3.promoted": "{0}, {1} e {2} gostam disto",
  "likes.summary.3.promoted.1.non-promoted": "{0}, {1}, {2} e {3} gostam disto",
  "likes.summary.you": "Você curtiu isso",
  "likes.summary.you.1.non-promoted": "Você e {0} gostam disto",
  "likes.summary.you.1.promoted": "Você e {0} gostam disto",
  "likes.summary.you.1.promoted.1.non-promoted": "Você, {0} e {1} gostam disto",
  "likes.summary.you.2.promoted": "Você, {0} e {1} gostam disto",
  "likes.summary.you.2.promoted.1.non-promoted": "Você, {0}, {1} e {2} curtiram isto",
  "likes.summary.you.3.promoted": "Você, {0}, {1} e {2} gostam disto",
  "likes.summary.you.3.promoted.1.non-promoted": "Você, {0}, {1}, {2} e {3} gostam disto",
  "likes.unlike": "Não gosto",
  "limited.mode.existing.editor.body": "A edição colaborativa está off-line agora, e {0} está editando esta página. Tente novamente em alguns minutos.",
  "link.browser.advanced.desc1": "Para inserir um link para uma nova página, introduza o título de página desejada.",
  "link.browser.advanced.desc2": "Para inserir um link de âncora, introduza #nomedaâncora.",
  "link.browser.advanced.error.internal.error": "Ocorreu um erro interno do servidor",
  "link.browser.advanced.error.not.link": "A marcação fornecida não é uma marcação de link válida",
  "link.browser.advanced.error.unknown.shortcut": "{0} não é um atalho reconhecido",
  "link.browser.advanced.error.unknown.space": "{0} não é um espaço reconhecido",
  "link.browser.advanced.title": "Aqui você pode inserir um link em uma página usando <a href=\"{0}\" target=\"_blank\">marcação wiki</a>.",
  "link.browser.autocomplete.hint": "Dica: Digite \"[\" no editor para exibir uma lista de páginas sugeridas e inserir um link.",
  "link.browser.cancel.button": "Cancelar",
  "link.browser.edit.button": "Inserir",
  "link.browser.edit.title": "Editar link",
  "link.browser.file.attach": "Carregar ficheiro",
  "link.browser.file.attach.desc": "Criar um link para um ficheiro anexo a esta página ou anexar um novo ficheiro.",
  "link.browser.file.attach.upload.in.progress": "Carregamento em progresso ...",
  "link.browser.file.browse.button": "Aceder",
  "link.browser.files.none": "Não há arquivos nesta página.",
  "link.browser.insert.button": "Inserir",
  "link.browser.insert.title": "Inserir link",
  "link.browser.link": "Link",
  "link.browser.link.alias": "Texto do link",
  "link.browser.link.image.label": "Imagem do link",
  "link.browser.location": "Local do link",
  "link.browser.recently.viewed.load.error": "Ocorreu um erro durante o carregamento das páginas vistas recentemente.",
  "link.browser.recently.viewed.none": "Não tem conteúdos recentemente vistos.",
  "link.browser.search": "Pesquisa",
  "link.browser.search.for": "Pesquisar por",
  "link.browser.search.invalid": "Termos de pesquisa inválidos",
  "link.browser.search.results.load.error": "Ocorreu um erro durante a pesquisa",
  "link.browser.search.results.none": "Esta pesquisa não devolveu nenhum resultado.",
  "link.browser.space.all": "Todo o conteúdo",
  "link.browser.tab.name.advanced": "Avançado",
  "link.browser.tab.name.files": "Arquivos",
  "link.browser.tab.name.recently.viewed": "Recentemente visto",
  "link.browser.tab.name.search": "Procurar",
  "link.browser.tab.name.weblinks": "Link da Web",
  "link.browser.table.file.comment": "Comentar",
  "link.browser.table.file.name": "Mome",
  "link.browser.table.file.size": "Tamanho",
  "link.browser.table.last.modified": "Última modificação",
  "link.browser.table.space": "Espaço",
  "link.browser.table.title": "Título",
  "link.browser.web.link": "URL",
  "link.browser.web.link.desc": "Web, e-mail ou outro endereço da internet",
  "link.browser.web.link.label": "Endereço",
  "location.name": "Localização",
  "login.button": "Autenticação",
  "look.and.feel": "Aparência",
  "marketplace.link.name": "Apps do Marketplace",
  "more.word.action": "Mais ações",
  "more.word.capitalised": "Mais",
  "moveblogpost.already.exists.in.target.space": "Outro posto de blog com o mesmo título e data já existe no espaço selecionado.",
  "moveblogpost.source.notfound": "O blogpost de origem não foi encontrado.",
  "moveblogpost.target.space.notfound": "O espaço de destino não foi encontrado.",
  "moveblogpost.target.space.same.as.origin": "Não é possível mover um post de blog para um espaço onde ele já existe.",
  "multimedia.file": "Arquivo multimídia",
  "my.drafts.mainBanner": "Capture ideias rapidamente",
  "my.drafts.subBanner": "Crie uma página e anote suas ideias. Se você ainda não estiver pronto para publicar o conteúdo, feche a página. Salvaremos tudo automaticamente como rascunho para que você possa retomar quando quiser. ",
  "my.spaces.tooltip.add": "Adicionar a Meus espaços",
  "my.spaces.tooltip.remove": "Remover de Meus espaços",
  "name.word": "Nome",
  "nav.controller.activity": "Atividade",
  "nav.controller.activity.feed": "Feed de atividades",
  "nav.controller.all.spaces": "Espaços",
  "nav.controller.discover": "Descubra",
  "nav.controller.my.spaces": "Meus espaços",
  "nav.controller.my.spaces.anchor": "Todos",
  "nav.controller.my.spaces.blank": "Mantenha os seus espaços mais úteis à mão. Clique no ícone de estrela ao lado de um espaço para que ele apareça aqui.",
  "nav.controller.my.spaces.blank.callToAction": "Encontrar espaços",
  "nav.controller.projects": "Projetos",
  "nav.controller.recent": "Páginas recentes",
  "nav.controller.your.work": "Seu trabalho",
  "navigation.app.switcher.apps": "Aplicativos",
  "navigation.app.switcher.dont.show.again": "Não exibir novamente",
  "navigation.app.switcher.edit": "Editar",
  "navigation.app.switcher.error-message": "Erro ao tentar adquirir os links da aplicação.",
  "navigation.app.switcher.home.description": "Página inicial",
  "navigation.app.switcher.img.alt": "Alternador de aplicativos",
  "navigation.app.switcher.loading": "Carregando...",
  "navigation.app.switcher.recent": "Recente",
  "navigation.app.switcher.recent-containers-confluence-space": "Espaço",
  "navigation.app.switcher.recent-containers-jira-project": "Projeto",
  "navigation.app.switcher.try.other.apps": "Experimentar outros aplicativos",
  "navigation.app.switcher.use.confluence": "Usar Confluência",
  "navigation.app.switcher.use.jira": "Usar Jira",
  "navigation.label-for-bell": "Notificações",
  "navigation.label-for-global-people-icon": "Diretório de pessoas",
  "navigation.notification-drawer-title": "Notificações da página inicial",
  "navigation.people-drawer-title": "Diretório de pessoas",
  "navlink.edit": "{0}E{1}ditar",
  "network.page": "Página da Rede",
  "no.drafts.found": "Nenhum rascunho encontrado.",
  "no.matches.mainBanner": "Não conseguimos encontrar nada para",
  "no.name": "Não",
  "no.permission": "Nenhuma Permissão",
  "no.spaces.found": "Não foi encontrado nenhum espaço.",
  "not.watching.anything": "Você não está observando nenhum conteúdo.",
  "notification.start": "Começar a acompanhar",
  "notification.stop": "Parar de Observar",
  "notifications.batch.inline.comment.created.section.header": "{0, choice, 1#Comentário em linha|1<Comentários em linha}",
  "notifications.batch.inline.comment.new.lozenge": "novo",
  "notifications.batch.inline.comment.reopened.lozenge": "reabriu",
  "notifications.batch.inline.comment.resolved": "$user $lozenge um comentário",
  "notifications.batch.inline.comment.resolved.lozenge": "resolveu",
  "notifications.preferences.desc": "Você pode definir as suas opções de e-mail de notificação na página <a href=\"viewmyemailsettings.action\">Configurações de email</a> .",
  "onboarding-choose-a-space.description": "Escolha um dos espaços atuais da sua equipe. Você poderá criar mais espaços posteriormente.",
  "onboarding-choose-a-space.title": "Escolha um espaço no qual deseja trabalhar",
  "onboarding.choose-a-space.backBtn": "Voltar",
  "onboarding.choose-a-space.nextBtn": "Avançar",
  "onboarding.choose-a-space.selectLabel": "Nome do espaço",
  "onboarding.choose-a-space.selectPlaceholder": "Selecione o nome do espaço",
  "onboarding.create-a-space.backBtn": "Voltar",
  "onboarding.create-a-space.description": "Comece com um espaço para sua equipe ou seu projeto atual. Você poderá criar mais espaços posteriormente.",
  "onboarding.create-a-space.inputTextLabel": "Nome",
  "onboarding.create-a-space.inputTextPlaceholder": "Crystal gems",
  "onboarding.create-a-space.invalidMessage": "Os nomes de espaços exigem pelo menos uma letra ou um número.",
  "onboarding.create-a-space.nextBtn": "Avançar",
  "onboarding.create-a-space.title": "Crie um espaço no qual deseja trabalhar",
  "onboarding.dialog.existing-user.cancel": "Não exibir dicas",
  "onboarding.dialog.existing-user.confirm": "Vamos lá",
  "onboarding.dialog.existing-user.content": "Mudamos algumas coisas para oferecer a você um painel ainda melhor, e também ativamos algumas dicas para lhe acompanhar em seus primeiros passos.",
  "onboarding.dialog.existing-user.title": "Nossas boas-vindas a seu novo painel!",
  "onboarding.dialog.new-user.cancel": "Não exibir dicas",
  "onboarding.dialog.new-user.confirm": "Vamos lá",
  "onboarding.dialog.new-user.content": "O painel é uma página de apresentação que ajuda a percorrer o Confluence.<br/>Ativamos algumas dicas para você dar seus primeiros passos",
  "onboarding.dialog.new-user.title": "Bem-vindo ao painel!",
  "onboarding.navigation.blog.tip.blog.list.byline": "Clique eu página inicial para abrir uma lista de página ou outros conteúdos.",
  "onboarding.navigation.blog.tip.blog.list.heading": "A lista do seu blog ainda pode ser encontrada aqui",
  "onboarding.navigation.dont.show": "Não exibir mais dicas",
  "onboarding.navigation.global.sidebar.byline": "Então, não importa em que parte do Confluence você estteja, as coisas importantes estão a apenas um clique.",
  "onboarding.navigation.global.sidebar.heading": "Esta barra lateral agora é universal",
  "onboarding.navigation.ok": "OK, entendi",
  "onboarding.navigation.page.tip.page.tree.byline": "Clique em página inicial para abrir uma lista de blogs ou outros conteúdos.",
  "onboarding.navigation.page.tip.page.tree.heading": "Sua página ainda pode ser encontrar aqui",
  "onboarding.navigation.space.tip.space.tabs.byline": "A página inicial do seu espaço agora está na visão geral, e suas páginas, publicações de blog e demais conteúdos têm sua própria aba.",
  "onboarding.navigation.space.tip.space.tabs.heading": "O conteúdo está organizado em guias",
  "onboarding.tooltip.actions.done": "Entendido!",
  "onboarding.tooltip.actions.next": "Próximo",
  "onboarding.tooltip.actions.skip": "Ignorar dicas",
  "onboarding.tooltip.existing-user.favourite-spaces.content": "Vá direto a seus espaços favoritos ou visite a lista de todos os espaços.",
  "onboarding.tooltip.existing-user.favourite-spaces.title": "Seus espaços favoritos na ponta dos dedos",
  "onboarding.tooltip.existing-user.sidebar.content": "Encontre novas páginas e volte ao seu trabalho mais recente usando a nova e engenhosa barra lateral.",
  "onboarding.tooltip.existing-user.sidebar.title": "Descubra mais com a barra lateral",
  "onboarding.tooltip.new-user.favourite-spaces.content": "Vá direto a seus espaços favoritos ou visite a lista de todos os espaços.",
  "onboarding.tooltip.new-user.favourite-spaces.title": "Seus espaços favoritos na ponta dos dedos",
  "onboarding.tooltip.new-user.sidebar.content": "Encontre novas páginas e volte ao seu último trabalho usando a barra lateral.",
  "onboarding.tooltip.new-user.sidebar.title": "Descubra mais com a barra lateral",
  "onboarding.tooltip.saved-for-later.content": "Agora, as suas páginas favoritas aparecem sob um novo nome: Salvo para mais tarde.",
  "onboarding.tooltip.saved-for-later.title": "Adeus Favoritos. Olá Salvos para mais tarde.",
  "onboarding.who-is-on-your-team.addMoreBtn": "+ Adicionar mais e-mails",
  "onboarding.who-is-on-your-team.description": "O Confluence fica melhor quando os colegas de equipe criam, debatem e colaboram em tarefas com você.",
  "onboarding.who-is-on-your-team.emailPlaceholder": "Adicionar endereço de e-mail",
  "onboarding.who-is-on-your-team.enableDRS": "Permita que qualquer pessoa com um endereço de e-mail {domain} verificado ingresse no seu site (avisaremos sempre que isso acontecer).",
  "onboarding.who-is-on-your-team.enableOpenInvite": "Permita que os usuários convidem outras pessoas ao seu site.",
  "onboarding.who-is-on-your-team.form.invalid.email": "Insira um e-mail válido",
  "onboarding.who-is-on-your-team.nextBtn": "Avançar",
  "onboarding.who-is-on-your-team.title": "Quem está na sua equipe?",
  "only.personal.labels.permitted": "Você só pode adicionar rótulos pessoais nesta página.",
  "org.randombits.confluence.toc.toc.label": "Índice",
  "page.already.exists": "Outra página com o mesmo título já existe no espaço selecionado.",
  "page.already.exists.inspace": "A página '{'0'}' já existe no espaço '{'1'}'. É preciso renomear o título antes de mover a página.",
  "page.change": "O que você alterou?",
  "page.comments.saved.dialog.message": "O seu comentário foi salvo como um comentário de página.",
  "page.comments.sidebar.warning": "Não podemos adicionar um comentário em linha a este conteúdo. Em vez disso, iremos adicioná-lo como um comentário da página.",
  "page.descendent.already.exists": "Existe uma página descendente que partilha o mesmo título com outra página no espaço selecionado.",
  "page.permissions.menu.item.title": "Restrições",
  "page.permissions.menu.item.title.tooltip": "Editar restrições",
  "page.tree.blankExperience.mainBanner": "Não há nada aqui além de potencial.",
  "page.tree.blankExperience.subBanner": "Comece a criar algumas notas de reuniões, requisitos do produto, artigos didáticos ou outro conteúdo para ver este espaço preenchido.",
  "page.watch.instruction": "Para acompanhar uma página ou notícia: abrir o menu ‘Ferramentas’  e escolha ‘Acompanhar’.",
  "page.watches": "Observadores da Página",
  "page.word": "Página",
  "pages.navigation.discovery.body.html": "Clique em <strong>Páginas</strong> para exibir a árvores de páginas e navegar por elas neste espaço.",
  "pages.navigation.discovery.header": "A árvore da página fica aqui agora",
  "pages.show.all": "Mostrar todas as páginas",
  "pages.word": "Páginas",
  "pagetree.dragndrop.failed.action.visitsupport": "Acessar o Suporte da Atlassian",
  "pagetree.dragndrop.failed.description": "Atualize a página e tente novamente. Se isso continuar acontecendo, informe-nos usando o link abaixo.",
  "pagetree.dragndrop.failed.title": "Algo deu errado.",
  "pagetree.failed.load.content": "Falha ao carregar árvore de páginas",
  "pagetree.failed.load.tooltip": "Estamos trabalhando para corrigir esse problema. Agradecemos sua paciência.",
  "parent.page.invalid.for.space": "Não existe uma página com o título <b>{0}</b> no espaço <b>{1}</b>.",
  "parent.page.name": "Página pai",
  "pdf.file": "Arquivo PDF",
  "people.directory.name": "Pessoas",
  "period.lastSevenDays": "Na semana passada",
  "period.lastThirtyDays": "No mês passado",
  "period.older": "Mais de um mês atrás",
  "period.today": "Hoje",
  "period.yesterday": "Ontem",
  "permission.owner.not.in.group": "Apenas pode conceder permissões de página para grupos aos quais pertence",
  "permission.owner.not.set": "Você deve escolher um dono para a permissão",
  "permissions.comment": "Definia quem pode visualizar e editar a página. Você pode restringir essas permissões para você ou um grupo de usuários.",
  "permissions.edit.title": "Editar",
  "permissions.select.nopermissions": "Não definido",
  "permissions.view.title": "Visualizar",
  "person.follow": "Seguir",
  "person.follow.stop": "Parar de Seguir",
  "personal.spaces": "Espaços pessoais",
  "placeholder.placeholdertext.label": "Texto do espaço reservado",
  "placeholder.replacementtext.label": "Texto substituto",
  "please.enter.a.label": "Por favor insira um rótulo.",
  "png.file": "Arquivo PNG",
  "popular.stream.mainBanner": "Não tem muita coisa acontecendo... Ainda",
  "popular.stream.subBanner": "As coisas estão calmas por enquanto, mas assim que o seu pessoal começar a criar, as páginas e os arquivos mais populares começarão a aparecer aqui.",
  "popular.stream.subBanner2": "Vamos começar a festa!",
  "popular.stream.title": "Populares",
  "posted.word": "Postado",
  "powerpoint.file": "Apresentação do Microsoft PowerPoint",
  "powerpoint.macro.file": "Apresentação do Microsoft PowerPoint com macros",
  "powerpoint.slideshow.file": "Apresentação do Microsoft PowerPoint",
  "powerpoint.template.file": "Template do Microsoft PowerPoint",
  "powerpoint97.file": "Apresentação de slides do Microsoft Powerpoint 97",
  "powerpoint97.template.file": "Template do Microsoft PowerPoint 97",
  "product.name": "Confluence",
  "profile.page": "Página de Perfil",
  "property.panel.macro.display.inline": "Mostrar em linha",
  "property.panel.macro.display.newline": "Mostrar em nova linha",
  "property.panel.macro.edit": "Alterar",
  "property.panel.macro.remove": "Eliminar",
  "property.panel.textplaceholder.display.default": "Texto",
  "property.panel.textplaceholder.display.default.tooltip": "Texto com instrução é substituído por conteúdo vazio quando uma pessoa digita.",
  "property.panel.textplaceholder.display.mention": "Citação do Usuário",
  "property.panel.textplaceholder.display.mention.tooltip": "Texto com instrução é substituído por pessoas sugeridas quando uma pessoa digita.",
  "property.panel.textplaceholder.remove": "Eliminar",
  "property.panel.variable.display.list": "Lista",
  "property.panel.variable.display.list.tooltip": "Lista suspensa",
  "property.panel.variable.display.string": "Texto",
  "property.panel.variable.display.string.tooltip": "Campo de entrada de texto de linha simples.",
  "property.panel.variable.display.textarea": "Texto multilinha",
  "property.panel.variable.display.textarea.tooltip": "Campo de entrada de texto multilinha.",
  "property.panel.variable.list.values.tooltip": "Insira os itens da lista, separando-os entre si por uma vírgula.",
  "property.panel.variable.textarea.columns.tooltip": "Número de colunas a exibir para o campo.",
  "property.panel.variable.textarea.rows.tooltip": "Número de linhas a exibir para o campo.",
  "quick.comment.placeholder.message": "Escreva um comentário...",
  "quick.reload.edit": "Edições à nova página",
  "quick.reload.edit.by": "por",
  "quick.reload.edit.more": "e {0} outros",
  "quick.reload.edit.one.more": "e 1 outro",
  "quick.reload.edits": "{0} novas edições",
  "quick.reload.newcomments": "{0} novos comentários",
  "quick.reload.newpagecomment": "Novo comentário",
  "quick.reload.reload": "Recarregar página",
  "recently-updated-content-list.commented.new": "Comentado em {time}",
  "recently-updated-content-list.created.new": "Criado {time}",
  "recently-updated-content-list.edited.new": "Atualizado em {time}",
  "recently.viewed.mainBanner": "É hora de fazer história",
  "recently.viewed.subBanner": "Você não visitou nenhuma página ainda, mas assim que o fizer a colocaremos aqui, para poder voltar a ela mais rápido.",
  "recently.viewed.subBanner2": "Paire sobre um <b>espaço</b> agora e dê uma olhada no que há por lá.",
  "recently.viewed.title": "Visitados recentemente",
  "recently.worked.mainBanner": "Finalizar essa obra-prima",
  "recently.worked.subBanner": "Você ainda não criou nem editou nada, mas assim que fizer algo colocaremos aqui, para ficar mais fácil para prosseguir de onde parou.",
  "recently.worked.subBanner2": "Agora crie o seu trabalho mais fenomenal.",
  "recently.worked.title": "Trabalhados recentemente",
  "remove.comment.confirmation.message": "Tem a certeza que pretende eliminar o comentário?",
  "remove.label": "Eliminar Etiqueta",
  "resize.image.dialog.title": "Redimensionar imagem",
  "restore.this.version": "Restaurar",
  "result.grid.column.content.last.modified": "Última Modificação",
  "resume.editing": "Continuar editando",
  "return.to.page.info": "Voltar às Informações da página",
  "satisfaction.survey.reaction.amazing": "Excelente",
  "satisfaction.survey.reaction.bad": "Ruim",
  "satisfaction.survey.reaction.great": "Ótima",
  "satisfaction.survey.reaction.okay": "Regular",
  "satisfaction.survey.reaction.terrible": "Terrível",
  "save.name": "Salvar",
  "scheme.desc.custom": "Um esquema de cores personalizado que pode ser editado.",
  "scheme.desc.global": "Este esquema de cores vai usar o esquema de cores definido globalmente para este espaço.",
  "scheme.title.custom": "Esquema de cores personalizado",
  "scheme.title.global": "Esquema de Cores Global",
  "search.drawer.recently.viewed": "Visualizados recentemente",
  "search.drawer.recently.viewed.spaces": "Espaços recentes",
  "search.name": "Pesquisar",
  "settings.name": "Configurações",
  "share.button.restriction.message.text": "As restrições desta página podem impedir que as pessoas visualizem ou editem",
  "share.button.text": "Compartilhar",
  "show.more.blogposts": "Mostrar mais posts do blog",
  "sidebar.avatar.picker.upload.error": "Ocorreu um erro ao atualizar detalhes do espaço",
  "sidebar.main.back.to.overview": "Voltar para a visão geral",
  "sidebar.main.back.to.space": "Voltar ao espaço",
  "sidebar.main.blog": "Notícias",
  "sidebar.main.quick.links": "Atalhos",
  "sidebar.main.settings": "Configurações do espaço",
  "sidebar.main.shortcuts": "Links",
  "sidebar.main.wiki": "Páginas",
  "site-settings.templates-and-blueprints.edit-button-label": "Editar",
  "space.404.banner.title": "Ops, você encontrou um link inoperante",
  "space.404.go.back": "Voltar para a",
  "space.404.go.to": "Ir para a",
  "space.404.home.page": "página inicial",
  "space.404.previous.page": "página anterior",
  "space.create": "Criar espaço",
  "space.home.blog.blankExperience.mainBanner": "Tem algo para compartilhar?",
  "space.home.blog.blankExperience.subBanner": "Publicações em blogs são uma ótima forma de compartilhar anúncios, relatórios de status ou outras informações importantes com sua equipe.",
  "space.home.overview.blankExperience.mainBanner": "Bem, isso é um pouco estranho.",
  "space.home.overview.blankExperience.subBanner": "Este espaço não tem uma página inicial, então não há nada para exibir aqui. Panda triste.",
  "space.home.overview.blankExperience.subBanner2": "Adicione uma página inicial agora para abrilhantar as coisas, e use isso para dizer a seus visitantes sobre o que é este espaço!",
  "space.not.exists": "O espaço que você especificou não existe.",
  "space.personal.name": "Espaço pessoal",
  "space.set.space.home": "Definir local do espaço",
  "space.watch.instruction": "Para acompanhar páginas ou notícias nos espaços, clique em ‘Páginas’ ou ‘Notícias’ na barra de navegação do espaço.",
  "space.watches": "Observadores deste espaço",
  "spaces.all": "Todos os espaços",
  "spaces.lookandfeel.help": "Aqui você pode personalizar o visual deste espaço.",
  "spaces.lookandfeel.note": "<span class=\"errorMessage\">Nota:</span> <i>Quaisquer modificações feitas aqui irão sobrepor o colour-scheme padrão e decorators padrão, os quais foram definidos pelo administrador.</i>",
  "spaces.word": "Espaços",
  "starred.mainBanner": "Não há nada para ver aqui... Ainda",
  "starred.spaces.tooltip.add": "Marcar este espaço com estrela",
  "starred.spaces.tooltip.remove": "Remover marcação com estrela deste espaço",
  "starred.subBanner": "Clique no <b>ícone de estrela</b> para salvar a página para mais tarde. Guardaremos ela aqui, para que você possa achá-la quando precisar.",
  "starred.title": "Salvo para mais tarde",
  "status.lozenge.draft": "Esboço",
  "status.lozenge.unpublished": "Alterações não publicadas",
  "submit.name": "Enviar",
  "super-admin.banner.exit": "Parar de usar a chave de administrador",
  "super-admin.banner.message": "Você está usando a chave de administração, o que concede acesso temporário a conteúdo restrito.",
  "switch.apps": "Alternar apps",
  "system.help.legal": "Jurídico",
  "team.create.flag.error.description": "Não foi possível criar uma equipe para você. Tente novamente em breve.",
  "team.create.flag.error.title": "Opa! Algo deu errado.",
  "team.created.flag.description": "{membersCount, plural, one {Você convidou {membersCount} pessoa para a equipe '{'teamName'}'} other {Você convidou {membersCount} pessoas para a equipe '{'teamName'}'}}",
  "team.created.flag.title": "Nova equipe criada",
  "team.created.flag.view": "Ver equipe",
  "template.variables.fabric.section.message": "Este template usa variáveis. Depois que você preenchê-las, as informações fornecidas por você passarão a fazer parte do conteúdo na sua nova página.",
  "templates.name": "Templates",
  "text.file": "Arq. Texto",
  "text.selected": "Selecionados",
  "tinymce.advanced.block": "Formato",
  "tinymce.advanced.blockquote": "Citação",
  "tinymce.advanced.blockquote_shortcut": "Ctrl+8",
  "tinymce.advanced.bold_desc": "Negrito",
  "tinymce.advanced.bold_shortcut": "Ctrl+B",
  "tinymce.advanced.bullist_desc": "Lista de Marcadores",
  "tinymce.advanced.bullist_shortcut": "Ctrl+Shift+B",
  "tinymce.advanced.charmap_desc": "Símbolo",
  "tinymce.advanced.forecolor_desc": "Selecione a cor do texto",
  "tinymce.advanced.formatting_desc": "Formatação",
  "tinymce.advanced.h1": "Título 1",
  "tinymce.advanced.h1_shortcut": "Ctrl+1",
  "tinymce.advanced.h2": "Título 2",
  "tinymce.advanced.h2_shortcut": "Ctrl+2",
  "tinymce.advanced.h3": "Título 3",
  "tinymce.advanced.h3_shortcut": "Ctrl+3",
  "tinymce.advanced.h4": "Título 4",
  "tinymce.advanced.h4_shortcut": "Ctrl+4",
  "tinymce.advanced.h5": "Título 5",
  "tinymce.advanced.h5_shortcut": "Ctrl+5",
  "tinymce.advanced.h6": "Título 6",
  "tinymce.advanced.h6_shortcut": "Ctrl +6",
  "tinymce.advanced.headings": "Títulos 1 a 6",
  "tinymce.advanced.headings_shortcut": "Ctrl +1 .. 6",
  "tinymce.advanced.hr_desc": "Linha horizontal",
  "tinymce.advanced.indent_desc": "Identar",
  "tinymce.advanced.italic_desc": "Itálico",
  "tinymce.advanced.italic_shortcut": "Ctrl + I",
  "tinymce.advanced.justifycenter_desc": "Alinhar ao centro",
  "tinymce.advanced.justifyfull_desc": "Alinhar justificado",
  "tinymce.advanced.justifyleft_desc": "Alinhar à esquerda",
  "tinymce.advanced.justifyright_desc": "Alinhar à direita",
  "tinymce.advanced.numlist_desc": "Lista numerada",
  "tinymce.advanced.numlist_shortcut": "Ctrl + Shift + N",
  "tinymce.advanced.outdent_desc": "Desidentar",
  "tinymce.advanced.paragraph": "Parágrafo",
  "tinymce.advanced.paragraph_shortcut": "Ctrl +0",
  "tinymce.advanced.pre": "Pré formatado",
  "tinymce.advanced.pre_shortcut": "Ctrl+7",
  "tinymce.advanced.redo_desc": "Refazer",
  "tinymce.advanced.redo_shortcut": "Ctrl + Y",
  "tinymce.advanced.striketrough_desc": "Riscado",
  "tinymce.advanced.striketrough_shortcut": "Ctrl + Shift + S",
  "tinymce.advanced.sub_desc": "Subscrito",
  "tinymce.advanced.sup_desc": "Sobrescrito",
  "tinymce.advanced.tasklist_desc": "Lista de tarefas",
  "tinymce.advanced.tasklist_shortcut": "[ depois ]",
  "tinymce.advanced.underline_desc": "Sublinhado",
  "tinymce.advanced.underline_shortcut": "Ctrl + U",
  "tinymce.advanced.undo_desc": "Desfazer",
  "tinymce.advanced.undo_shortcut": "Ctrl + Z",
  "tinymce.advanced.unlink_desc": "Remover link",
  "tinymce.atlassian.help": "Ajuda",
  "tinymce.atlassian.insert_menu": "Inserir",
  "tinymce.atlassian.insert_menu.charmap_desc": "Inserir símbolo",
  "tinymce.atlassian.insert_menu.content_desc": "Inserir conteúdo",
  "tinymce.atlassian.insert_menu.hr_desc": "Inserir linha horizontal (----)",
  "tinymce.atlassian.insert_menu.macro_desc": "Inserir macro",
  "tinymce.atlassian.insert_menu.tooltip": "Inserir mais conteúdo",
  "tinymce.atlassian.monospace": "Espaço simples",
  "tinymce.atlassian.monospace_desc": "Formatar texto com fonte de espaço simples",
  "tinymce.atlassian.more_menu": "Mais",
  "tinymce.atlassian.remove_formatting": "Limpar formatação",
  "tinymce.atlassian.remove_formatting_desc": "Limpa a formatação do texto selecionado",
  "tinymce.auiwindowmanager.cancel": "Cancelar",
  "tinymce.auiwindowmanager.ok": "OK",
  "tinymce.autocomplete.web.resource.name": "Recursos da web de autopreenchimento do Confluence",
  "tinymce.autocomplete.web.resource.only.name": "Recursos da web de autopreenchimento do Confluence com dependências",
  "tinymce.charmap.web.resource.name": "Recursos da web de mapa de caracteres TinyMce",
  "tinymce.charmap_dlg.title": "Inserir símbolo",
  "tinymce.colorpicker.color": "Cor",
  "tinymce.colorpicker.more_colors": "Mais cores",
  "tinymce.colorpicker.picker_tab": "Seletor",
  "tinymce.colorpicker.picker_title": "Seletor de cores",
  "tinymce.colorpicker.title": "Selecionar uma cor",
  "tinymce.colorpicker.web.resource.name": "Seletor de cores de recursos da web do Confluence",
  "tinymce.confluence.conf_emoji": "Emoji",
  "tinymce.confluence.conf_emoticon": "Emoticon",
  "tinymce.confluence.conf_emoticon_desc": "Inserir emoticon",
  "tinymce.confluence.conf_file": "Arquivos e imagens",
  "tinymce.confluence.conf_file_desc": "Inserir arquivos e imagens",
  "tinymce.confluence.conf_file_shortcut": "Ctrl + M",
  "tinymce.confluence.conf_image": "Imagem",
  "tinymce.confluence.conf_image_desc": "Inserir imagem",
  "tinymce.confluence.conf_image_shortcut": "Ctrl + M",
  "tinymce.confluence.conf_link": "Link",
  "tinymce.confluence.conf_link_desc": "Inserir link",
  "tinymce.confluence.conf_link_shortcut": "Ctrl + K",
  "tinymce.confluence.conf_macro_browser": "Macro",
  "tinymce.confluence.conf_macro_browser_desc": "Inserir macro",
  "tinymce.confluence.conf_macro_browser_shortcut": "Ctrl + Shift + A",
  "tinymce.confluence.conf_media": "Imagem / Mídia",
  "tinymce.confluence.conf_other_macros_desc": "Outras macros...",
  "tinymce.confluence.conf_shortcuts_help": "Ajuda dos atalhos de teclado",
  "tinymce.confluence.conf_tasklist": "Lista de Tarefas",
  "tinymce.confluence.conf_tasklist_desc": "Insert lista de tarefas",
  "tinymce.confluence.conf_tasklist_shortcut": "[ depois ]",
  "tinymce.confluence.conf_widget_desc": "Widget",
  "tinymce.confluence.conf_wikimarkup": "Marcação",
  "tinymce.confluence.conf_wikimarkup.insert.label": "Inserir",
  "tinymce.confluence.conf_wikimarkup_confluence_label": "Confluence wiki",
  "tinymce.confluence.conf_wikimarkup_conversion_errors": "Erros de conversão de marcação wiki",
  "tinymce.confluence.conf_wikimarkup_desc": "Inserir markup",
  "tinymce.confluence.conf_wikimarkup_hint": "Dica: Você também pode inserir uma marcação wiki diretamente no editor, onde ela será formatada conforme você digita.",
  "tinymce.confluence.conf_wikimarkup_info_title": " Insira a marcação ou redução wiki abaixo. O Confluence irá converter o conteúdo para o formato do editor e inseri-lo na sua página.",
  "tinymce.confluence.conf_wikimarkup_markdown_label": "Marcação",
  "tinymce.confluence.conf_wikimarkup_preview_label": "Visualizar",
  "tinymce.confluence.conf_wikimarkup_shortcut": "Ctrl + Shift + D",
  "tinymce.confluence.conf_wikimarkup_timeout": "O servidor demorou muito para converter a marcação wiki. Este pode ser um problema temporário você pode tentar novamente.",
  "tinymce.confluence.files": "Arquivos",
  "tinymce.confluence.help_desc": "Ajuda",
  "tinymce.confluence.htmlsource": "Origem",
  "tinymce.confluence.htmlsource_desc": "Exibir origem HTML",
  "tinymce.confluence.layout.menu": "Layout da Página",
  "tinymce.confluence.layout.none": "Sem Layout",
  "tinymce.confluence.layout.three_col": "Três colunas",
  "tinymce.confluence.layout.three_col_sidebars": "Três colunas (sidebars esquerda e direita)",
  "tinymce.confluence.layout.three_col_simple": "Três colunas (simples)",
  "tinymce.confluence.layout.two_col": "Duas colunas",
  "tinymce.confluence.layout.two_col_left": "Duas colunas (barra lateral esquerda)",
  "tinymce.confluence.layout.two_col_right": "Duas colunas (barra lateral direita)",
  "tinymce.confluence.layout.two_col_simple": "Duas colunas (simples)",
  "tinymce.confluence.layout.two_col_simple_left": "Duas colunas (simples, barra esquerda)",
  "tinymce.confluence.layout.two_col_simple_right": "Duas colunas (simples, barra direita)",
  "tinymce.confluence.macro_insert": "Inserir macro '{'0'}'",
  "tinymce.confluence.macro_other": "Outras macros",
  "tinymce.confluence.macro_other_desc": "Procurar outras macros",
  "tinymce.confluence.placeholder.inline.tasks": "Introduza aqui a sua tarefa, utilizando  \"@\" para atribuí-la a um utilizador e \"//\" para selecionar uma data de conclusão",
  "tinymce.confluence.preview": "Pré-visualizar",
  "tinymce.confluence.preview_shortcut": "Ctrl + Shift + E",
  "tinymce.confluence.save_shortcut": "Ctrl + S",
  "tinymce.confluence.settings_desc": "Configurações do Editor",
  "tinymce.confluence_dlg.insertbutton.title": "Inserir",
  "tinymce.confluence_dlg.insertimage.title": "Inserir imagem",
  "tinymce.confluence_dlg.insertlink.title": "Inserir link",
  "tinymce.emotions.emotions_desc": "Emoticons",
  "tinymce.emotions.web.resource.name": "Recursos da web emotions TinyMce",
  "tinymce.emotions_dlg.add": "Mais (+)",
  "tinymce.emotions_dlg.biggrin": "Grande sorriso :D",
  "tinymce.emotions_dlg.broken_heart": "Coração partido </3",
  "tinymce.emotions_dlg.check": "Marca (/)",
  "tinymce.emotions_dlg.desc": "Emoticons",
  "tinymce.emotions_dlg.error": "Erro (x)",
  "tinymce.emotions_dlg.forbidden": "Menos (-)",
  "tinymce.emotions_dlg.heart": "Coração <3",
  "tinymce.emotions_dlg.help_16": "Ponto de interrogação (?)",
  "tinymce.emotions_dlg.information": "Info (i)",
  "tinymce.emotions_dlg.lightbulb": "Lâmpada apagada (off)",
  "tinymce.emotions_dlg.lightbulb_on": "Lâmpada acesa (on)",
  "tinymce.emotions_dlg.sad": "Triste :(",
  "tinymce.emotions_dlg.smile": "Sorriso:)",
  "tinymce.emotions_dlg.star_blue": "Estrela azul (*b)",
  "tinymce.emotions_dlg.star_green": "Estrela verde (*g)",
  "tinymce.emotions_dlg.star_red": "Estrela vermelha (*r)",
  "tinymce.emotions_dlg.star_yellow": "Estrela amarela (*y)",
  "tinymce.emotions_dlg.thumbs_down": "Negativo (n)",
  "tinymce.emotions_dlg.thumbs_up": "Positivo (y)",
  "tinymce.emotions_dlg.title": "Inserir emoticon",
  "tinymce.emotions_dlg.tongue": "Careta :p",
  "tinymce.emotions_dlg.warning": "Atenção (\\!)",
  "tinymce.emotions_dlg.wink": "Piscada ;)",
  "tinymce.fabric.migration.dialog.action": "Continue a editar",
  "tinymce.fabric.migration.dialog.content": "Não se preocupe, suas alterações não foram perdidas. Apenas precisamos atualizar sua página.",
  "tinymce.fabric.migration.dialog.title": "Acabamos de atualizar a sua experiência de edição",
  "tinymce.formatting.paragraph": "Texto normal",
  "tinymce.full_screen.toolbar_item": "Tela cheia",
  "tinymce.full_screen.toolbar_item_title": "Iniciar editor em tela cheia",
  "tinymce.hints.autoformat.code": "Dica: digite \"<strong>'{{'code'}}'</strong>\" para digitar texto em espaço simples mais rápido.",
  "tinymce.hints.autoformat.heading1": "Dica: Digite \"<strong>h1. Título</strong>\" para inserir rapidamente um Cabeçalho 1.",
  "tinymce.hints.autoformat.heading3": "Dica: Digite \"<strong>h3. Título</strong>\" para inserir rapidamente um Cabeçalho 3.",
  "tinymce.hints.dnd": "Dica: Você pode arrastar e soltar imagens e arquivos do Office do seu computador diretamente para este editor.",
  "tinymce.hints.drafts": "Dica: O Confluence salva rascunhos automaticamente. Se você perder uma janela, poderá recuperar o seu trabalho no menu \"Nome de usuário -> Rascunhos\".",
  "tinymce.hints.insert.bullet.list": "Dica: Pressione <strong>Ctrl+Shift+B</strong> para iniciar uma lista com marcadores.",
  "tinymce.hints.insert.heading": "Dica: Pressione <strong>Ctrl+1</strong> para criar um cabeçalho nível 1, <strong>Ctrl+2</strong>, para um cabeçalho nível 2, e assim por diante.",
  "tinymce.hints.insert.image": "Dica: Pressione <strong>Ctrl+M</strong> para abrir o navegador de imagem.",
  "tinymce.hints.insert.image.end": "Dica: Pressione <strong>Ctrl+Shift+M</strong> depois de uma palavra e insira as imagens relevantes.",
  "tinymce.hints.insert.image.on.page": "Dica: Digite \"<strong>\\!</strong>\" para ver as imagens anexadas à página e inserir uma delas.",
  "tinymce.hints.insert.image.search": "Dica: Digite \"<strong>\\!</strong>\" e parte do nome de uma imagem para encontrar e inserir a imagem.",
  "tinymce.hints.insert.link": "Dica: Pressione <strong>Ctrl+K</strong> para abrir o navegador de link.",
  "tinymce.hints.insert.link.end": "Dica: Pressione <strong>Ctrl+Shift+K</strong> depois de uma palavra para encontrá-la e vinculá-la a páginas relevantes. Pressione novamente para obter mais sugestões.",
  "tinymce.hints.insert.link.newpage": "Dica: Digite \"<strong>[</strong>\" e o título de uma nova página que desejar criar para ver a sugestão de links para inserção.",
  "tinymce.hints.insert.link.recently.viewed": "Dica: Digite \"<strong>[</strong>\" para ver uma lista de páginas sugeridas e inserir um link.",
  "tinymce.hints.insert.link.search": "Dica: Digite \"<strong>[</strong>\" e parte do título de uma página para encontrá-la e vincular-se a ela.",
  "tinymce.hints.insert.link.user.mention": "Dica: Você pode mencionar alguém no Confluence escrevendo \"<strong>@</strong>\" e depois o nome da pessoa.",
  "tinymce.hints.insert.macro": "Dica: Pressione <strong>Ctrl+Shift+A</strong> para abrir o navegador de macro.",
  "tinymce.hints.insert.macro.toc": "Dica: Deixe o Confluence gerar o sumário desta página. Use \"Inserir -> Sumário\"",
  "tinymce.hints.insert.newline": "Dica: Digite <strong>Shift+Enter</strong> para inserir um novo parágrafo sem espaçamento",
  "tinymce.hints.insert.numbered.list": "Dica: Pressione <strong>Ctrl+Shift+N</strong> para iniciar uma lista numerada.",
  "tinymce.hints.insert.table": "Dica: Pressione <strong>Ctrl+Shift+I</strong> para inserir uma tabela.",
  "tinymce.hints.insert.wikimarkup": "Dica: O Editor converterá automaticamente a marcação wiki conforme você digita.",
  "tinymce.hints.insert.wikimarkup.dialog": "Dica: Pressione <strong>Ctrl+Shift+D</strong> para abrir o diálogo Marcação Wiki.",
  "tinymce.hints.table.rows.copy": "Dica: pressione Ctrl + Shift + C <strong> </ strong> para copiar uma linha e as teclas Ctrl + Shift + V <strong> </ strong> para colar uma linha numa tabela.",
  "tinymce.hints.table.rows.cut": "Dica: pressione Ctrl + Shift + <strong> X </ strong> para cortar uma linha e as teclas <strong> Ctrl + Shift + V </ strong> para colar uma linha numa tabela.",
  "tinymce.macro.preview.exception": "Ocorreu uma exceção ao pré-visualizar a macro. Exceção: {0}",
  "tinymce.macro.unknownMacro": "A macro '{'0'}' é desconhecida. Ela pode ter sido removida do sistema.",
  "tinymce.popup_blocked": "O navegador bloqueou uma janela aberta pelo Editor.",
  "tinymce.propertypanel.images.border": "Borda",
  "tinymce.propertypanel.images.border.tooltip": "Exibir uma borda ao redor da imagem",
  "tinymce.propertypanel.images.large": "Grande",
  "tinymce.propertypanel.images.large.tooltip": "Redimensione a imagem para o tamanho grande e vincule-a ao original",
  "tinymce.propertypanel.images.link.create": "Ligação",
  "tinymce.propertypanel.images.link.create.tooltip": "Vincula esta imagem a outro conteúdo",
  "tinymce.propertypanel.images.link.edit": "Editar link",
  "tinymce.propertypanel.images.link.edit.tooltip": "Editar a ligação para esta imagem",
  "tinymce.propertypanel.images.link.remove": "Remover ligação",
  "tinymce.propertypanel.images.link.remove.tooltip": "Remover a ligação para esta imagem",
  "tinymce.propertypanel.images.medium": "Média",
  "tinymce.propertypanel.images.medium.tooltip": "Formate a imagem para o tamanho médio e crie um link para o original",
  "tinymce.propertypanel.images.original": "Original",
  "tinymce.propertypanel.images.original.tooltip": "Restaurar o tamanho original da imagem",
  "tinymce.propertypanel.images.sizing.tooltip": "Redimensione a imagem para uma largura específica",
  "tinymce.propertypanel.images.small": "Pequeno",
  "tinymce.propertypanel.images.small.tooltip": "Redimensione a imagem para o tamanho pequeno e vincule-a ao original",
  "tinymce.propertypanel.links.edit": "Editar",
  "tinymce.propertypanel.links.edit.tooltip": "Editar link em um diálogo",
  "tinymce.propertypanel.links.goto": "Ir para Link",
  "tinymce.propertypanel.links.goto.disabled.tooltip": "Ligação para conteúdo na página que está a editar",
  "tinymce.propertypanel.links.unlink": "Remover ligação",
  "tinymce.propertypanel.links.unlink.tooltip": "Substituir link com o texto que contém",
  "tinymce.searchreplace.replace_desc": "Procurar / Substituir",
  "tinymce.searchreplace.search_desc": "Localizar",
  "tinymce.searchreplace_dlg.allreplaced.plural": "{0} substituições",
  "tinymce.searchreplace_dlg.allreplaced.singular": "Foi realizada 1 substituição",
  "tinymce.searchreplace_dlg.close": "Fechar",
  "tinymce.searchreplace_dlg.direction": "Direção",
  "tinymce.searchreplace_dlg.down": "Para baixo",
  "tinymce.searchreplace_dlg.findlabel": "Localizar",
  "tinymce.searchreplace_dlg.findnext": "Próximo",
  "tinymce.searchreplace_dlg.findprevious": "Anterior",
  "tinymce.searchreplace_dlg.findwhat": "Encontrar algo",
  "tinymce.searchreplace_dlg.mcase": "Diferenciar maiúculas de minúsculas",
  "tinymce.searchreplace_dlg.notfound": "Não foram realizadas substituições",
  "tinymce.searchreplace_dlg.replace": "Substituir",
  "tinymce.searchreplace_dlg.replace_title": "Localizar/Substituir",
  "tinymce.searchreplace_dlg.replaceall": "Substituir todos",
  "tinymce.searchreplace_dlg.replacelabel": "Substituir",
  "tinymce.searchreplace_dlg.search_title": "Localizar",
  "tinymce.searchreplace_dlg.searchnext_desc": "Procurar novamente",
  "tinymce.searchreplace_dlg.up": "Para cima",
  "tinymce.style.show-eol-markers": "¶",
  "tinymce.style.show-eol-markers.title": "Mostrar/Ocultar marcadores de fim de linha",
  "tinymce.table": "Tabela",
  "tinymce.table.cell": "Célula",
  "tinymce.table.col": "Coluna",
  "tinymce.table.col_after_desc": "Inserir coluna depois",
  "tinymce.table.col_after_desc_shortcut_mac": "Control+Option+→",
  "tinymce.table.col_after_desc_shortcut_win": "Alt+Shift+→",
  "tinymce.table.col_before_desc": "Inserir coluna antes",
  "tinymce.table.col_before_desc_shortcut_mac": "Control+Option+←",
  "tinymce.table.col_before_desc_shortcut_win": "Alt+Shift+←",
  "tinymce.table.col_copy_desc": "Copiar coluna da tabela",
  "tinymce.table.col_cut_desc": "Recortar coluna da tabela",
  "tinymce.table.col_highlight": "Coluna de cabeçalho",
  "tinymce.table.col_paste_desc": "Colar coluna da tabela",
  "tinymce.table.copy_row_desc": "Copiar linha da tabela",
  "tinymce.table.copy_row_shortcut": "Ctrl + Shift + C",
  "tinymce.table.cut_row_desc": "Recortar linha da tabela",
  "tinymce.table.cut_row_shortcut": "Ctrl + Shift + X",
  "tinymce.table.del": "Remover tabela",
  "tinymce.table.delete_col_desc": "Remover coluna",
  "tinymce.table.delete_row_desc": "Remover linha",
  "tinymce.table.desc": "Inserir tabela",
  "tinymce.table.fixed_width": "Largura fixa",
  "tinymce.table.fixed_width_tooltip": "Arraste as bordas da coluna para definir a largura. A tabela aparece sempre com a largura que você definir.",
  "tinymce.table.highlight_colour": "Cor de realce",
  "tinymce.table.merge_cells_desc": "Mesclar células da tabela",
  "tinymce.table.more.heading": "Configurações da tabela",
  "tinymce.table.numbering_column_desc": "Inserir número da coluna",
  "tinymce.table.paste_row_after_desc": "Colar linha depois",
  "tinymce.table.paste_row_before_desc": "Colar linha da tabela",
  "tinymce.table.paste_row_before_shortcut": "Ctrl + Shift + V",
  "tinymce.table.responsive": "Receptivo",
  "tinymce.table.responsive_tooltip": "As colunas da tabela ficam mais largas à medida em que você adiciona conteúdo. Arraste as bordas da coluna para definir a largura em relação à outra e à página.",
  "tinymce.table.row": "Linha",
  "tinymce.table.row_after_desc": "Inserir linha depois",
  "tinymce.table.row_after_desc_shortcut_mac": "Control+Option+↓",
  "tinymce.table.row_after_desc_shortcut_win": "Alt+Shift+↓",
  "tinymce.table.row_after_shortcut": "Alt +",
  "tinymce.table.row_before_desc": "Inserir linha antes",
  "tinymce.table.row_before_desc_shortcut_mac": "Control+Option+↑",
  "tinymce.table.row_before_desc_shortcut_win": "Alt+Shift+↑",
  "tinymce.table.row_before_shortcut": "Alt +",
  "tinymce.table.row_highlight": "Linha de cabeçalho",
  "tinymce.table.selection_highlight": "Alterar cor da célula",
  "tinymce.table.split_cells_desc": "Dividir células mescladas",
  "tinymce.table_dlg.cols": "Colunas",
  "tinymce.table_dlg.equal.width.columns": "Colunas com largura igual",
  "tinymce.table_dlg.fullwidth": "Largura total",
  "tinymce.table_dlg.heading": "A primeira linha é título",
  "tinymce.table_dlg.invalid_table_field": "Linhas e colunas devem ter números maiores que zero.",
  "tinymce.table_dlg.rows": "Linhas",
  "tinymce.table_dlg.sizetofit": "Tamanho do conteúdo",
  "tinymce.table_dlg.title": "Inserir tabela",
  "tinymce.table_dlg.width": "Lagura",
  "tinymce.table_shortcut": "Ctrl+Shift+I",
  "tinymce.tablepicker.insert_table": "Tabela",
  "tinymce.tablepicker.insert_table_title": "Inserir tabela",
  "tinymce.tablepicker.nested_table_unsupported": "Tabelas aninhadas não são suportadas",
  "tinymce.tablepicker.pickerbox.tooltip": "Pressione a tecla SHIFT para uma tabela sem um título.",
  "tinymce.templates.actions.defined": "Itens a inserir nesta página.",
  "tinymce.templates.insert-template": "Template",
  "tinymce.templates.insert-template.tooltip": "Inserir itens de template nesta página.",
  "tinymce.templates.placeholder": "Texto com instrução",
  "tinymce.templates.placeholder.add": "Espaço reservado",
  "tinymce.templates.placeholder.add.tooltip": "Insira um espaço reservado para texto na página.",
  "tinymce.templates.placeholder.tooltip": "Desaparece quando um usuário digita, não exibido ao visualizar uma página.",
  "tinymce.templates.variables.add": "Nova variável",
  "tinymce.templates.variables.add.tooltip": "Adicione um novo campo à página para o usuário do template preencher.",
  "tinymce.templates.variables.defined": "Variáveis a inserir nesta página.",
  "tinymce.templates.variables.insert.tooltip": "Insira o campo '{'0'}' na página para o usuário do template preencher.",
  "tinymce.templates.variables.manage": "Gerenciar variáveis",
  "tinymce.templates.variables.none": "Nenhuma variável definida",
  "tinymce.templates.variables.none.tooltip": "Nenhuma variável foi criada.",
  "tinymce.tools.toolbar_item_hide": "Ocultar ferramentas",
  "tinymce.tools.toolbar_item_hide_title": "Ocultar barras de ferramentas",
  "tinymce.tools.toolbar_item_show": "Mostrar ferramentas",
  "tinymce.tools.toolbar_item_show_title": "Mostrar barras de ferramentas",
  "tinymce.web.css.resource.name": "Editor CSS de recursos da web do Confluence",
  "tinymce.web.js.resource.name": "Editor Javascript de recursos da web do Confluence",
  "tinymce.web.resource.name": "Editor de recursos da web do Confluence",
  "title.add.blogpost": "Adicionar Blog Post",
  "title.add.page": "Adicionar Página",
  "title.add.page.template": "Criar template",
  "title.comment": "Comentário",
  "title.dashboard": "Painel",
  "title.edit.page.template": "Editar template",
  "title.manage.groups": "Grupos",
  "title.name": "Título",
  "type.allcontent": "Todo o Conteúdo",
  "unknown.file": "Arquivo",
  "unsaved.comment.lost": "O seu comentário será perdido.",
  "unsaved.content.lost": "As alterações feitas podem não ser salvas.",
  "unsaved.template.lost": "Suas alterações ao template salvas serão perdidas.",
  "untitled.draft.title": "Sem título",
  "upm.marketplace.section": "Atlassian Marketplace",
  "usermanagement.label": "Gerenciamento de usuário",
  "usermanagement.parent.label": "Administração do site",
  "users.name": "Usuários",
  "view-changes-dialog.close.dialog": "Fechar",
  "view-changes-dialog.editor.quit-dialog.title.diff": "Alterações não publicadas",
  "view.change": "exibir alterações",
  "view.profile": "Visualizar perfil",
  "viewdrafts.page.desc": "Quando você edita uma página mas não publica as alterações, um rascunho é criado. Pressione <b>Resumir</b> para continuar a edição ou publicar as alterações.",
  "welcome.message.edit": "Compartilhe links úteis, avisos e informações aqui",
  "welcome.message.edit.link": "Personalizar",
  "word.file": "Documento do Microsoft Word",
  "word.template.file": "Template do Microsoft Word",
  "word97.file": "Documento do Microsoft Word 97",
  "word97.template.file": "Template do Microsoft Word 97",
  "xml.file": "Arquivo XML",
  "yes.name": "Sim",
  "your.profile.and.settings": "Seu perfil e configurações",
  "zip.file": "Arquivo ZIP"
}